{
  "about.blocks": "Moderované servery",
  "about.contact": "Kontakt:",
  "about.default_locale": "Výchozí",
  "about.disclaimer": "Mastodon je svobodný software s otevřeným zdrojovým kódem a ochranná známka společnosti Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "Důvod není k dispozici",
  "about.domain_blocks.preamble": "Mastodon umožňuje prohlížet obsah a komunikovat s uživateli jakéhokoliv serveru ve fediversu. Pro tento konkrétní server se vztahují následující výjimky.",
  "about.domain_blocks.silenced.explanation": "Uživatele a obsah tohoto serveru neuvidíte, pokud je nebudete výslovně hledat nebo je nezačnete sledovat.",
  "about.domain_blocks.silenced.title": "Omezeno",
  "about.domain_blocks.suspended.explanation": "Žádná data z tohoto serveru nebudou zpracovávána, uložena ani vyměňována, což znemožňuje jakoukoli interakci nebo komunikaci s uživateli z tohoto serveru.",
  "about.domain_blocks.suspended.title": "Pozastaveno",
  "about.language_label": "Jazyk",
  "about.not_available": "Tato informace nebyla zpřístupněna na tomto serveru.",
  "about.powered_by": "Decentralizovaná sociální média poháněná {mastodon}",
  "about.rules": "Pravidla serveru",
  "account.account_note_header": "Osobní poznámka",
  "account.activity": "Aktivita",
  "account.add_note": "Přidat vlastní poznámku",
  "account.add_or_remove_from_list": "Přidat nebo odstranit ze seznamů",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Zablokovaný",
  "account.badges.bot": "Bot",
  "account.badges.domain_blocked": "Zablokovaná doména",
  "account.badges.group": "Skupina",
  "account.badges.muted": "Ztišeno",
  "account.badges.muted_until": "Ztišen do {until}",
  "account.block": "Blokovat @{name}",
  "account.block_domain": "Blokovat doménu {domain}",
  "account.block_short": "Zablokovat",
  "account.blocked": "Blokovaný",
  "account.cancel_follow_request": "Zrušit sledování",
  "account.copy": "Kopírovat odkaz na profil",
  "account.direct": "Soukromě zmínit @{name}",
  "account.disable_notifications": "Přestat mě upozorňovat, když @{name} zveřejní příspěvek",
  "account.edit_note": "Upravit vlastní poznámku",
  "account.edit_profile": "Upravit profil",
  "account.edit_profile_short": "Upravit",
  "account.enable_notifications": "Oznamovat mi příspěvky @{name}",
  "account.endorse": "Zvýraznit na profilu",
  "account.familiar_followers_many": "Sleduje je {name1}, {name2} a {othersCount, plural, one {jeden další, které znáte} few {# další, které znáte} many {# dalších, které znáte} other {# dalších, které znáte}}",
  "account.familiar_followers_one": "Sleduje je {name1}",
  "account.familiar_followers_two": "Sleduje je {name1} a {name2}",
  "account.featured": "Zvýrazněné",
  "account.featured.accounts": "Profily",
  "account.featured.collections": "Kolekce",
  "account.featured.new_collection": "Nová kolekce",
  "account.field_overflow": "Zobrazit celý obsah",
  "account.filters.all": "Veškerá aktivita",
  "account.filters.boosts_toggle": "Zobrazit boosty",
  "account.filters.posts_boosts": "Příspěvky a boosty",
  "account.filters.posts_only": "Příspěvky",
  "account.filters.posts_replies": "Příspěvky a odpovědi",
  "account.filters.replies_toggle": "Zobrazit odpovědi",
  "account.follow": "Sledovat",
  "account.follow_back": "Také sledovat",
  "account.follow_back_short": "Také sledovat",
  "account.follow_request": "Požádat o sledování",
  "account.follow_request_cancel": "Zrušit požadavek",
  "account.follow_request_cancel_short": "Zrušit",
  "account.follow_request_short": "Požádat",
  "account.followers": "Sledující",
  "account.followers.empty": "Tohoto uživatele zatím nikdo nesleduje.",
  "account.followers_counter": "{count, plural, one {{counter} sledující} few {{counter} sledující} many {{counter} sledujících} other {{counter} sledujících}}",
  "account.followers_you_know_counter": "{count, one {{counter}, kterého znáte}, few {{counter}, které znáte}, many {{counter}, kterých znáte} other {{counter}, kterých znáte}}",
  "account.following": "Sledujete",
  "account.following_counter": "{count, plural, one {{counter} sledovaný} few {{counter} sledovaní} many {{counter} sledovaných} other {{counter} sledovaných}}",
  "account.follows.empty": "Tento uživatel zatím nikoho nesleduje.",
  "account.follows_you": "Sleduje vás",
  "account.go_to_profile": "Přejít na profil",
  "account.hide_reblogs": "Skrýt boosty od @{name}",
  "account.in_memoriam": "In Memoriam.",
  "account.join_modal.day": "Den",
  "account.join_modal.me": "Připojil/a jsi se k {server} dne",
  "account.join_modal.me_anniversary": "Šťastné Fediversary! Připojil/a jsi se k {server} dne",
  "account.join_modal.me_today": "Toto je tvůj první den na {server}!",
  "account.join_modal.other": "{name} se připojil/a k {server} dne",
  "account.join_modal.other_today": "První den {name} na {server}!",
  "account.join_modal.share.celebrate": "Sdílet oslavný příspěvek",
  "account.join_modal.share.intro": "Sdílet úvodní příspěvek",
  "account.join_modal.share.welcome": "Sdílet uvítací příspěvek",
  "account.join_modal.years": "{number, plural, one {# den} few {# dny} many {# dní} other {# dní}}",
  "account.joined_short": "Připojen/a",
  "account.languages": "Změnit odebírané jazyky",
  "account.last_active": "Naposledy aktivní",
  "account.link_verified_on": "Vlastnictví tohoto odkazu bylo zkontrolováno {date}",
  "account.locked_info": "Stav soukromí tohoto účtu je nastaven na zamčeno. Jeho vlastník ručně posuzuje, kdo ho může sledovat.",
  "account.media": "Média",
  "account.mention": "Zmínit @{name}",
  "account.menu.add_to_collection": "Přidat do kolekce…",
  "account.menu.add_to_list": "Přidat do seznamu…",
  "account.menu.block": "Blokovat účet",
  "account.menu.block_domain": "Blokovat {domain}",
  "account.menu.copied": "Odkaz účtu byl zkopírován do schránky",
  "account.menu.copy": "Zkopírovat odkaz",
  "account.menu.direct": "Soukromě zmínit",
  "account.menu.hide_reblogs": "Skrýt boosty na časové ose",
  "account.menu.mention": "Zmínit",
  "account.menu.mute": "Ztlumit účet",
  "account.menu.note.description": "Viditelné pouze pro vás",
  "account.menu.open_original_page": "Zobrazit na {domain}",
  "account.menu.remove_follower": "Odstranit sledujícího",
  "account.menu.report": "Nahlásit účet",
  "account.menu.share": "Sdílet…",
  "account.menu.show_reblogs": "Zobrazit boosty na časové ose",
  "account.menu.unblock": "Odblokovat účet",
  "account.menu.unblock_domain": "Odblokovat {domain}",
  "account.menu.unmute": "Zrušit ztlumení účtu",
  "account.moved_to": "Uživatel {name} uvedl, že jeho nový účet je nyní:",
  "account.mute": "Skrýt @{name}",
  "account.mute_notifications_short": "Ztlumit upozornění",
  "account.mute_short": "Ztlumit",
  "account.muted": "Skrytý",
  "account.mutual": "Sledujete se navzájem",
  "account.name.copy": "Zkopírovat handle",
  "account.name.help.domain": "{domain} je server, který hostuje profily a příspěvky uživatelů.",
  "account.name.help.domain_self": "{domain} je váš server, který hostuje váš profil a příspěvky.",
  "account.name.help.footer": "Stejně jako můžete posílat emaily lidem využívajícím různé poskytovatele emailu, můžete komunikovat i s uživateli na jiných serverech sítě Mastodon a s kýmkoli na dalších aplikacích v rámci Fediversu.",
  "account.name.help.header": "Handle je jako e-mailová adresa",
  "account.name.help.username": "{username} je uživatelské jméno tohoto účtu na jeho serveru. Někdo na jiném serveru může mít stejné uživatelské jméno.",
  "account.name.help.username_self": "{username} je vaše uživatelské jméno na tomto serveru. Někdo na jiném serveru může mít stejné uživatelské jméno.",
  "account.name_info": "Co to znamená?",
  "account.no_bio": "Nebyl poskytnut žádný popis.",
  "account.node_modal.callout": "Vlastní poznámky jsou viditelné pouze pro vás.",
  "account.node_modal.edit_title": "Upravit vlastní poznámku",
  "account.node_modal.error_unknown": "Poznámka nemohla být uložena",
  "account.node_modal.field_label": "Vlastní poznámka",
  "account.node_modal.save": "Uložit",
  "account.node_modal.title": "Přidat vlastní poznámku",
  "account.note.edit_button": "Upravit",
  "account.note.title": "Vlastní poznámka (viditelná pouze pro vás)",
  "account.open_original_page": "Otevřít původní stránku",
  "account.pending": "Nevyřízeno",
  "account.posts": "Příspěvky",
  "account.remove_from_followers": "Odebrat {name} ze sledujících",
  "account.report": "Nahlásit @{name}",
  "account.requested_follow": "{name} tě požádal o sledování",
  "account.share": "Sdílet profil @{name}",
  "account.show_reblogs": "Zobrazit boosty od @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} příspěvek} few {{counter} příspěvky} many {{counter} příspěvků} other {{counter} příspěvků}}",
  "account.timeline.pinned": "Připnuto",
  "account.timeline.pinned.view_all": "Zobrazit všechny připnuté příspěvky",
  "account.unblock": "Odblokovat @{name}",
  "account.unblock_domain": "Odblokovat doménu {domain}",
  "account.unblock_domain_short": "Odblokovat",
  "account.unblock_short": "Odblokovat",
  "account.unendorse": "Nezvýrazňovat na profilu",
  "account.unfollow": "Přestat sledovat",
  "account.unmute": "Zrušit skrytí @{name}",
  "account.unmute_notifications_short": "Zrušit ztlumení oznámení",
  "account.unmute_short": "Zrušit skrytí",
  "account_edit.advanced_settings.bot_hint": "Upozornit ostatní, že účet provádí zejména automatizované akce a nemusí být monitorován",
  "account_edit.advanced_settings.bot_label": "Automatizovaný účet",
  "account_edit.advanced_settings.title": "Rozšířená nastavení",
  "account_edit.bio.add_label": "Přidat informace o sobě",
  "account_edit.bio.edit_label": "Editovat informace o sobě",
  "account_edit.bio.placeholder": "Přidejte krátký úvod a pomozte ostatním vás poznat.",
  "account_edit.bio.title": "O vás",
  "account_edit.bio_modal.add_title": "Přidat informace o sobě",
  "account_edit.bio_modal.edit_title": "Editovat informace o sobě",
  "account_edit.column_button": "Hotovo",
  "account_edit.column_title": "Upravit profil",
  "account_edit.custom_fields.add_label": "Přidat pole",
  "account_edit.custom_fields.edit_label": "Upravit pole",
  "account_edit.custom_fields.placeholder": "Přidejte svá zájmena, externí odkazy nebo cokoliv jiného, co chcete sdílet.",
  "account_edit.custom_fields.reorder_button": "Přeuspořádat pole",
  "account_edit.custom_fields.tip_content": "Důvěryhodnost svého účtu na Mastodonu můžete provést vložením ověřených odkazů na jakékoliv vámi vlastněné webové stránce.",
  "account_edit.custom_fields.tip_title": "Tip: Přidání ověřených odkazů",
  "account_edit.custom_fields.title": "Vlastní pole",
  "account_edit.custom_fields.verified_hint": "Jak přidám ověřený odkaz?",
  "account_edit.display_name.add_label": "Přidat zobrazované jméno",
  "account_edit.display_name.edit_label": "Upravit zobrazované jméno",
  "account_edit.display_name.placeholder": "Zobrazované jméno říká, jak se vaše jméno bude zobrazovat na vašem profilu a v časových osách.",
  "account_edit.display_name.title": "Zobrazované jméno",
  "account_edit.featured_hashtags.edit_label": "Přidat hashtagy",
  "account_edit.featured_hashtags.placeholder": "Pomozte ostatním poznat a snadno zpřístupnit vaše oblíbená témata.",
  "account_edit.featured_hashtags.title": "Zvýrazněné hashtagy",
  "account_edit.field_actions.delete": "Smazat pole",
  "account_edit.field_actions.edit": "Upravit pole",
  "account_edit.field_delete_modal.confirm": "Jste si jistý/á, že chcete smazat toto uživatelské pole? Tuto akci nelze vrátit zpět.",
  "account_edit.field_delete_modal.delete_button": "Smazat",
  "account_edit.field_delete_modal.title": "Smazat uživatelské pole?",
  "account_edit.field_edit_modal.add_title": "Přidat uživatelské pole",
  "account_edit.field_edit_modal.discard_confirm": "Zahodit",
  "account_edit.field_edit_modal.discard_message": "Máte neuložené změny. Jste si jistý/á, že je chcete zahodit?",
  "account_edit.field_edit_modal.edit_title": "Upravit uživatelské pole",
  "account_edit.field_edit_modal.length_warning": "Překročen doporučený limit znaků. Uživatelé mobilních zařízení nemusí vidět vaše pole celé.",
  "account_edit.field_edit_modal.link_emoji_warning": "Nedoporučujeme používat vlastní emoji v kombinaci s url adresami. Uživatelská pole, která obsahují oboje, se budou zobrazovat pouze jako text, nikoli jako odkaz, aby nedocházelo k matení uživatelů.",
  "account_edit.field_edit_modal.name_hint": "Např. \"Osobní webová stránka\"",
  "account_edit.field_edit_modal.name_label": "Popisek",
  "account_edit.field_edit_modal.url_warning": "Pro přidání odkazu vložte prosím na začátek {protocol}.",
  "account_edit.field_edit_modal.value_hint": "Např. \"https://priklad.cz\"",
  "account_edit.field_edit_modal.value_label": "Hodnota",
  "account_edit.field_reorder_modal.drag_cancel": "Přetažení bylo zrušeno. Pole \"{item}\" bylo puštěno.",
  "account_edit.field_reorder_modal.drag_end": "Pole \"{item}\" bylo upuštěno.",
  "account_edit.field_reorder_modal.drag_instructions": "K přesunutí uživatelských polí stiskněte mezerník nebo enter. Při přetahování použijte klávesy šipek pro pohyb nahoru nebo dolů. Pro uložení pole na nové pozici stiskněte znovu mezerník nebo enter, případně escape pro přerušení.",
  "account_edit.field_reorder_modal.drag_move": "Pole \"{item}\" bylo přesunuto.",
  "account_edit.field_reorder_modal.drag_over": "Pole \"{item}\" bylo přesunuto přes \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Vybráno pole \"{item}\".",
  "account_edit.field_reorder_modal.handle_label": "Přetáhněte pole \"{item}\"",
  "account_edit.field_reorder_modal.title": "Přeuspořádat pole",
  "account_edit.image_alt_modal.add_title": "Přidat alternativní text",
  "account_edit.image_alt_modal.details_content": "CO DĚLAT: <ul> <li>Popište se, jak jste na obrázku</li> <li>Vyjádřete se ve třetí osobě (např. \"Alex“ místo \"já\")</li> <li>Buďte struční – pár slov stačí</li> </ul> CO NEDĚLAT: <ul> <li>Začínat s \"Fotka toho a toho\" – pro čtečky obrazovek je to nadbytečné</li> </ul> PŘÍKLAD: <ul> <li>\"Alex oblečený v zelené košili a s brýlemi\"</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Tipy: Alt text pro profilové fotky",
  "account_edit.image_alt_modal.edit_title": "Upravit alt text",
  "account_edit.image_alt_modal.text_hint": "Alt text pomáhá uživatelům používajícím čtečku obrazovky porozumět vašemu obsahu.",
  "account_edit.image_alt_modal.text_label": "Alternativní text",
  "account_edit.image_delete_modal.confirm": "Opravdu chcete smazat tento obrázek? Tuto akci nelze vrátit.",
  "account_edit.image_delete_modal.delete_button": "Smazat",
  "account_edit.image_delete_modal.title": "Smazat obrázek?",
  "account_edit.image_edit.add_button": "Přidat obrázek",
  "account_edit.image_edit.alt_add_button": "Přidat alt text",
  "account_edit.image_edit.alt_edit_button": "Upravit alt text",
  "account_edit.image_edit.remove_button": "Odstranit obrázek",
  "account_edit.image_edit.replace_button": "Nahradit obrázek",
  "account_edit.item_list.delete": "Odstranit {name}",
  "account_edit.item_list.edit": "Upravit {name}",
  "account_edit.name_modal.add_title": "Přidat zobrazované jméno",
  "account_edit.name_modal.edit_title": "Upravit zobrazované jméno",
  "account_edit.profile_tab.button_label": "Přizpůsobit",
  "account_edit.profile_tab.hint.description": "Tato nastavení upravují to, co uživatelé vidí na {server} v oficiálních aplikacích, ale nemusí se vztahovat na uživatele na jiných serverech a aplikacích třetích stran.",
  "account_edit.profile_tab.hint.title": "Zobrazení se může lišit",
  "account_edit.profile_tab.show_featured.description": "'Zvýrazněné' je volitelná záložka, kde můžete prezentovat jiné účty.",
  "account_edit.profile_tab.show_featured.title": "Zobrazit záložku 'Zvýrazněné'",
  "account_edit.profile_tab.show_media.description": "'Média' je volitelná záložka, kde se zobrazují vaše příspěvky, které obsahují obrázky či videa.",
  "account_edit.profile_tab.show_media.title": "Zobrazit záložku 'Média'",
  "account_edit.profile_tab.show_media_replies.description": "Je-li povoleno, zobrazují se na záložce Média vaše příspěvky a odpovědi na příspěvky ostatních.",
  "account_edit.profile_tab.show_media_replies.title": "Zahrnout odpovědi na záložce 'Média'",
  "account_edit.profile_tab.show_relations.description": "Zobrazí na vašem profilu účty, které sledujete a které sledují vás ostatním uživatelům, ostatním uživatelům. Lidé budou stále moci vidět, zda je sledujete.",
  "account_edit.profile_tab.show_relations.title": "Zobrazit 'Sledující' a 'Sledované'",
  "account_edit.profile_tab.subtitle": "Přizpůsobte si, jak je váš profil zobrazen.",
  "account_edit.profile_tab.title": "Nastavení zobrazení profilu",
  "account_edit.save": "Uložit",
  "account_edit.upload_modal.back": "Zpět",
  "account_edit.upload_modal.done": "Hotovo",
  "account_edit.upload_modal.next": "Další",
  "account_edit.upload_modal.step_crop.zoom": "Přiblížit",
  "account_edit.upload_modal.step_upload.button": "Procházet soubory",
  "account_edit.upload_modal.step_upload.dragging": "Přetáhněte pro nahrání",
  "account_edit.upload_modal.step_upload.header": "Vyberte obrázek",
  "account_edit.upload_modal.step_upload.hint": "Formát WEBP, PNG, GIF nebo JPG, maximálně {limit}MB.{br}Obrázek bude převeden na rozměry {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Přidat profilovou fotku",
  "account_edit.upload_modal.title_add.header": "Přidat úvodní fotku",
  "account_edit.upload_modal.title_replace.avatar": "Nahradit profilovou fotku",
  "account_edit.upload_modal.title_replace.header": "Nahradit úvodní fotku",
  "account_edit.verified_modal.details": "Přidejte důvěryhodnost svého profilu Mastodon ověřenými odkazy na osobní webové stránky. Jak to funguje:",
  "account_edit.verified_modal.invisible_link.details": "Přidejte odkaz do hlavičky. Důležitá část je rel=\"me\", která zabraňuje zneužití identity na webových stránkách s uživatelsky generovaným obsahem. Místo {tag} můžete v hlavičce stránky použít dokonce i tag link, ale HTML kód musí být přístupný i bez spuštění JavaScriptu.",
  "account_edit.verified_modal.invisible_link.summary": "Jak zneviditelním odkaz?",
  "account_edit.verified_modal.step1.header": "Zkopírujte HTML kód níže a vložte do hlavičky vašeho webu",
  "account_edit.verified_modal.step2.details": "Pokud jste již v uživatelském poli měli svůj web přidaný, budete jej muset smazat a přidat znova, aby se spustila verifikace.",
  "account_edit.verified_modal.step2.header": "Přidejte svou webovou stránku jako uživatelské pole",
  "account_edit.verified_modal.title": "Jak přidat ověřený odkaz",
  "account_edit_tags.add_tag": "Přidat #{tagName}",
  "account_edit_tags.column_title": "Upravit štítky",
  "account_edit_tags.help_text": "Doporučené hashtagy pomáhají uživatelům objevovat a interagovat s vaším profilem. V pohledu Aktivita na vaší profilové stránce se zobrazí jako filtry.",
  "account_edit_tags.max_tags_reached": "Dosáhli jste maximálního počtu doporučených hashtagů.",
  "account_edit_tags.search_placeholder": "Zadejte hashtag…",
  "account_edit_tags.suggestions": "Návrhy:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# příspěvek} few {# příspěvky} many {# příspěvků} other {# příspěvků}}",
  "account_list.hidden_notice": "Toto vidíte pouze vy. Pro zobrazení seznamů ostatním, pokračujte na <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# minuta} few {# minuty} many {# minut} other {# minut}}",
  "admin.dashboard.daily_retention": "Míra udržení uživatelů podle dne po registraci",
  "admin.dashboard.monthly_retention": "Míra udržení uživatelů podle měsíce po registraci",
  "admin.dashboard.retention.average": "Průměr",
  "admin.dashboard.retention.cohort": "Měsíc registrace",
  "admin.dashboard.retention.cohort_size": "Noví uživatelé",
  "admin.impact_report.instance_accounts": "Profily účtů, které by byly smazány",
  "admin.impact_report.instance_followers": "Sledující, o které by naši uživatelé přišli",
  "admin.impact_report.instance_follows": "Sledující, o které by jejich uživatelé přišli",
  "admin.impact_report.title": "Shrnutí dopadu",
  "alert.need_reload.message": "Mastodon byl aktualizován. Některé věci nemusí fungovat, dokud nenačtete stránku znovu.",
  "alert.rate_limited.message": "Zkuste to prosím znovu po {retry_time, time, medium}.",
  "alert.rate_limited.title": "Spojení omezena",
  "alert.unexpected.message": "Objevila se neočekávaná chyba.",
  "alert.unexpected.title": "Jejda!",
  "alt_text_badge.title": "Popisek",
  "alt_text_modal.add_alt_text": "Přidat popisek",
  "alt_text_modal.add_text_from_image": "Přidat text z obrázku",
  "alt_text_modal.cancel": "Zrušit",
  "alt_text_modal.change_thumbnail": "Změnit náhled",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Popište to pro osoby se sluchovým postižením…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Popište to pro osoby se zrakovým postižením…",
  "alt_text_modal.done": "Hotovo",
  "announcement.announcement": "Oznámení",
  "annual_report.announcement.action_build": "Sestavit můj Wrapstodon",
  "annual_report.announcement.action_dismiss": "Ne, děkuji",
  "annual_report.announcement.action_view": "Zobrazit můj Wrapstodon",
  "annual_report.announcement.description": "Zjistěte více o vaší aktivitě na Mastodonu za poslední rok.",
  "annual_report.announcement.title": "Je zde Wrapstodon {year}",
  "annual_report.nav_item.badge": "Nový",
  "annual_report.shared_page.donate": "Podpořit",
  "annual_report.shared_page.footer": "Vytvořeno s {heart} týmem Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} používá {domain}, jednu z mnoha komunit poháněných Mastodonem.",
  "annual_report.summary.archetype.booster.desc_public": "{name} zůstali na honu za příspěvky a podporovali ostatní tvůrce s dokonalým mířením.",
  "annual_report.summary.archetype.booster.desc_self": "Zůstali jste na honu za příspěvky a podporovali ostatní tvůrce s dokonalým mířením.",
  "annual_report.summary.archetype.booster.name": "Lučištník",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Víme, že {name} tu někde byli a užívali si Mastodon svým vlastním klidným způsobem.",
  "annual_report.summary.archetype.lurker.desc_self": "Víme, že jste tu někde byli a užívali si Mastodon svým vlastním klidným způsobem.",
  "annual_report.summary.archetype.lurker.name": "Stoik",
  "annual_report.summary.archetype.oracle.desc_public": "{name} vytvořili více nových příspěvků než odpovědí a zachovávali Mastodon čerstvým a orientovaným do budoucnosti.",
  "annual_report.summary.archetype.oracle.desc_self": "Vytvořili jste více nových příspěvků než odpovědí a zachovávali Mastodon čerstvým a orientovaným do budoucnosti.",
  "annual_report.summary.archetype.oracle.name": "Vědma",
  "annual_report.summary.archetype.pollster.desc_public": "{name} vytvořili více průzkumů než jiných typů příspěvků, čímž na Mastodonu pěstovali zvědavost.",
  "annual_report.summary.archetype.pollster.desc_self": "Vytvořili jste více průzkumů než jiných typů příspěvků, čímž na Mastodonu pěstovali zvědavost.",
  "annual_report.summary.archetype.pollster.name": "Myslitel",
  "annual_report.summary.archetype.replier.desc_public": "{name} často odpovídali na příspěvky ostatních a opylovávali Mastodon novými diskuzemi.",
  "annual_report.summary.archetype.replier.desc_self": "Často jste odpovídali na příspěvky ostatních a opylovávali Mastodon novými diskuzemi.",
  "annual_report.summary.archetype.replier.name": "Motýlek",
  "annual_report.summary.archetype.reveal": "Odhalit můj archetyp",
  "annual_report.summary.archetype.reveal_description": "Děkujeme, že jste součástí Mastodonu! Čas zjistit, který archetype jste ztělesnili v roce {year}.",
  "annual_report.summary.archetype.title_public": "Archetyp {name}",
  "annual_report.summary.archetype.title_self": "Váš archetyp",
  "annual_report.summary.close": "Zavřít",
  "annual_report.summary.copy_link": "Zkopírovat odkaz",
  "annual_report.summary.followers.new_followers": "{count, plural, one {nový sledující} other {noví sledující}}",
  "annual_report.summary.highlighted_post.boost_count": "Tento příspěvek byl boostnut {count, plural, one {jednou} other {# krát}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Tento příspěvek byl oblíben {count, plural, one {jednou} other {# krát}}.",
  "annual_report.summary.highlighted_post.reply_count": "Tento příspěvek dostal {count, plural, one {jednu odpověď} few {# odpovědi} other {# odpovědí}}.",
  "annual_report.summary.highlighted_post.title": "Nejpopulárnější příspěvek",
  "annual_report.summary.most_used_app.most_used_app": "nejpoužívanější aplikace",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "nejpoužívanější hashtag",
  "annual_report.summary.most_used_hashtag.used_count": "Tento hashtag jste vložili do {count, plural, one {jednoho příspěvku} few {# příspěvků} many {# příspěvků} other {# příspěvků}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} vložili tento hashtag do {count, plural, one {jednoho příspěveku} few {# příspěvků} many {# příspěvků} other {# příspěvků}}.",
  "annual_report.summary.new_posts.new_posts": "nové příspěvky",
  "annual_report.summary.percentile.text": "<topLabel>To vás umisťuje do horních</topLabel><percentage></percentage><bottomLabel> uživatelů domény {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "To, že jste zdejší smetánka, zůstane mezi námi ;).",
  "annual_report.summary.share_elsewhere": "Sdílet jinde",
  "annual_report.summary.share_message": "Mám archetyp {archetype}!",
  "annual_report.summary.share_on_mastodon": "Sdílet na Mastodonu",
  "attachments_list.unprocessed": "(nezpracováno)",
  "audio.hide": "Skrýt zvuk",
  "block_modal.no_collections": "Nemůžete se vzájemně přidávat do kolekcí. Pokud to bude možné, budete automaticky z existujících sbírek druhého odstraněn.",
  "block_modal.remote_users_caveat": "Požádáme server {domain}, aby respektoval vaše rozhodnutí. Úplné dodržování nastavení však není zaručeno, protože některé servery mohou řešit blokování různě. Veřejné příspěvky mohou být stále viditelné pro nepřihlášené uživatele.",
  "block_modal.show_less": "Zobrazit méně",
  "block_modal.show_more": "Zobrazit více",
  "block_modal.they_cant_mention": "Nemůžete se zmínit, sledovat, ani vzájemně citovat.",
  "block_modal.they_cant_see_posts": "Nemůže vidět váš příspěvek a vy neuvidíte jeho/její.",
  "block_modal.they_will_know": "Může vidět, že je zablokovaný.",
  "block_modal.title": "Zablokovat uživatele?",
  "block_modal.you_wont_see_mentions": "Neuvidíte příspěvky ostatních, které ho/ji zmiňují.",
  "boost_modal.combo": "Příště můžete pro přeskočení stisknout {combo}",
  "boost_modal.reblog": "Boostnout příspěvek?",
  "boost_modal.undo_reblog": "Zrušit boostování příspěvku?",
  "bundle_column_error.copy_stacktrace": "Zkopírovat zprávu o chybě",
  "bundle_column_error.error.body": "Požadovanou stránku nelze vykreslit. Může to být způsobeno chybou v našem kódu nebo problémem s kompatibilitou prohlížeče.",
  "bundle_column_error.error.title": "Ale ne!",
  "bundle_column_error.network.body": "Při pokusu o načtení této stránky došlo k chybě. To může být způsobeno dočasným problémem s připojením k internetu nebo k tomuto serveru.",
  "bundle_column_error.network.title": "Chyba sítě",
  "bundle_column_error.retry": "Zkusit znovu",
  "bundle_column_error.return": "Zpět na domovskou stránku",
  "bundle_column_error.routing.body": "Požadovaná stránka nebyla nalezena. Opravdu je URL v adresním řádku správně?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Zavřít",
  "bundle_modal_error.message": "Něco se pokazilo při načítání této obrazovky.",
  "bundle_modal_error.retry": "Zkusit znovu",
  "callout.dismiss": "Zamítnout",
  "carousel.current": "<sr>Snímek</sr> {current, number}/{max, number}",
  "carousel.slide": "Snímek {current, number} z {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} doporučených znaků",
  "character_counter.required": "{currentLength}/{maxLength} znaků",
  "closed_registrations.other_server_instructions": "Protože Mastodon je decentralizovaný, můžete si vytvořit účet na jiném serveru a přesto komunikovat s tímto serverem.",
  "closed_registrations_modal.description": "V současné době není možné vytvořit účet na {domain}, ale mějte prosím na paměti, že k používání Mastodonu nepotřebujete účet konkrétně na {domain}.",
  "closed_registrations_modal.find_another_server": "Najít jiný server",
  "closed_registrations_modal.preamble": "Mastodon je decentralizovaný, takže bez ohledu na to, kde vytvoříte svůj účet, budete moci sledovat a komunikovat s kýmkoli na tomto serveru. Můžete ho dokonce hostovat!",
  "closed_registrations_modal.title": "Registrace na Mastodon",
  "collection.share_modal.share_link_label": "Sdílet odkaz",
  "collection.share_modal.share_via_post": "Příspěvek na Mastodon",
  "collection.share_modal.share_via_system": "Sdílet na…",
  "collection.share_modal.title": "Sdílet kolekci",
  "collection.share_modal.title_new": "Sdílejte svou novou kolekci!",
  "collection.share_template_other": "Podívejte se na tuto skvělou kolekci:",
  "collection.share_template_own": "Podívejte se na mou novou kolekci:",
  "collections.account_count": "{count, plural, one {# účet} few {# účty} many {# účtů} other {# účtů}}",
  "collections.accounts.empty_description": "Přidat nejvýše {count} účtů",
  "collections.accounts.empty_editor_title": "Ve sbírce zatím nikdo není",
  "collections.accounts.empty_title": "Tato kolekce je prázdná",
  "collections.add_to_collection": "Přidat {name} do sbírek",
  "collections.block_collection_owner": "Blokovat účet",
  "collections.by_account": "od {account_handle}",
  "collections.collection_description": "Popis",
  "collections.collection_language": "Jazyk",
  "collections.collection_language_none": "Žádný",
  "collections.collection_name": "Název",
  "collections.collection_topic": "Téma",
  "collections.confirm_account_removal": "Jste si jisti, že chcete odstranit tento účet z této kolekce?",
  "collections.content_warning": "Varování o obsahu",
  "collections.continue": "Pokračovat",
  "collections.copy_link": "Zkopírovat odkaz",
  "collections.copy_link_confirmation": "Odkaz na kolekci zkopírován do schránky",
  "collections.create.accounts_title": "Koho ve sbírce zvýrazníte?",
  "collections.create.basic_details_title": "Základní údaje",
  "collections.create.steps": "Krok {step}/{total}",
  "collections.create_collection": "Vytvořit kolekci",
  "collections.create_new_collection": "Vytvorit novou kolekci",
  "collections.delete_collection": "Smazat kolekci",
  "collections.description_length_hint": "Nejvýše 100 znaků",
  "collections.detail.author_added_you_on_date": "{author} tě přidal dne {date}",
  "collections.detail.loading": "Načítání kolekce…",
  "collections.detail.revoke_inclusion": "Odebrat mě",
  "collections.detail.sensitive_content": "Citlivý obsah",
  "collections.detail.sensitive_note": "Popis a účty nemusí být vhodné pro některé vhodné.",
  "collections.detail.share": "Sdílet tuto kolekci",
  "collections.detail.you_are_in_this_collection": "Jste v této sbírce zvýrazněn/á",
  "collections.edit_details": "Upravit podrobnosti",
  "collections.error_loading_collections": "Při pokusu o načtení těchto sbírek došlo k chybě.",
  "collections.hidden_accounts_description": "Zablokovali jste nebo umlčeli {count, plural, one {tohoto uživatele} few {tyto uživatele} many {tyto uživatele} other {tyto uživatele}}",
  "collections.hidden_accounts_link": "{count, plural, one {# skrytý účet} few {# skryté účty} many {# skrytých účtů} other {# skrytých účtů}}",
  "collections.hints.accounts_counter": "{count}/{max} účtů",
  "collections.last_updated_at": "Naposledy aktualizováno: {date}",
  "collections.list.collections_with_count": "{count, plural, one {Kolekce} few {Kolekce} many {Kolekcí} other {Kolekcí}}",
  "collections.list.created_by_author": "Vytvořil/a {name}",
  "collections.list.created_by_you": "Vytvořeno vámi",
  "collections.list.featuring_you": "Obsahuje vás",
  "collections.manage_accounts": "Spravovat účty",
  "collections.mark_as_sensitive": "Označit jako citlivé",
  "collections.mark_as_sensitive_hint": "Skryje popis kolekce a účty za varováním obsahu. Název kolekce bude stále viditelný.",
  "collections.maximum_collection_count_description": "Váš server umožňuje vytvořit až {count} sbírek.",
  "collections.maximum_collection_count_reached": "Dosáhl/a jste maximálního počtu sbírek",
  "collections.name_length_hint": "Limit 40 znaků",
  "collections.new_collection": "Nová kolekce",
  "collections.pending_accounts.message": "Účty se mohou zobrazovat jako nevyřízené během čekání na odpověď od uživatele nebo jeho/jejího serveru. Pouze vy můžete vidět nevyřízené účty.",
  "collections.pending_accounts.title": "Proč vidím nevyřízené účty?",
  "collections.remove_account": "Odebrat",
  "collections.report_collection": "Nahlásit tuto kolekci",
  "collections.revoke_collection_inclusion": "Odstranit sebe z této kolekce",
  "collections.revoke_inclusion.confirmation": "Byl/a jsi odstraněn z \"{collection}\"",
  "collections.revoke_inclusion.error": "Došlo k chybě, zkuste to znovu později.",
  "collections.search_accounts_label": "Hledat účty pro přidání",
  "collections.search_accounts_max_reached": "Přidali jste maximální počet účtů",
  "collections.sensitive": "Citlivé",
  "collections.share_short": "Sdílet",
  "collections.sort_alphabetical": "Abecedně",
  "collections.sort_by": "Seřadit podle:",
  "collections.sort_date_added": "Data přidání",
  "collections.sort_last_active": "Poslední aktivity",
  "collections.sort_most_followers": "Nejvíce sledujících",
  "collections.suggestions.can_not_add": "Nelze přidat",
  "collections.suggestions.can_not_add_desc": "Tyto účty se možná odhlásily z možnosti objevování a nebo jsou na serveru, které nepodporují kolekce.",
  "collections.suggestions.must_follow": "Je třeba nejprve sledovat",
  "collections.suggestions.must_follow_desc": "Tyto účty kontrolují všechny žádosti o sledování. Sledující je mohou přidat do sbírek.",
  "collections.topic_hint": "Přidat štítek, který pomůže ostatním pochopit hlavní téma této kolekce.",
  "collections.topic_special_chars_hint": "Speciální znaky budou při uložení odstraněny",
  "collections.unlisted_collections_description": "Tyto se na vašem profilu ostatním nezobrazují. Kdokoliv s odkazem je může objevit.",
  "collections.unlisted_collections_with_count": "Nezařazené kolekce ({count})",
  "collections.view_collection": "Zobrazit kolekci",
  "collections.visibility_public": "Veřejné",
  "collections.visibility_public_hint": "Objevitelné ve výsledcích vyhledávání a dalších místech, kde se objevují doporučení.",
  "collections.visibility_title": "Viditelnost",
  "collections.visibility_unlisted": "Neveřejný",
  "collections.visibility_unlisted_hint": "Viditelné všem s odkazem. Skryté ve výsledcích vyhledávání a doporučeních.",
  "column.about": "O aplikaci",
  "column.blocks": "Blokovaní uživatelé",
  "column.bookmarks": "Záložky",
  "column.community": "Místní časová osa",
  "column.create_list": "Vytvořit seznam",
  "column.direct": "Soukromé zmínky",
  "column.directory": "Prozkoumat profily",
  "column.domain_blocks": "Blokované domény",
  "column.edit_list": "Upravit seznam",
  "column.favourites": "Oblíbené",
  "column.firehose": "Živé kanály",
  "column.firehose_local": "Živý kanál pro tento server",
  "column.firehose_singular": "Živý kanál",
  "column.follow_requests": "Žádosti o sledování",
  "column.home": "Domů",
  "column.list_members": "Spravovat členy seznamu",
  "column.lists": "Seznamy",
  "column.mutes": "Skrytí uživatelé",
  "column.notifications": "Oznámení",
  "column.other_collections": "Kolekce od {name}",
  "column.pins": "Připnuté příspěvky",
  "column.public": "Federovaná časová osa",
  "column.your_collections": "Vaše Kolekce",
  "column_back_button.label": "Zpět",
  "column_header.hide_settings": "Skrýt nastavení",
  "column_header.moveLeft_settings": "Posunout sloupec doleva",
  "column_header.moveRight_settings": "Posunout sloupec doprava",
  "column_header.pin": "Připnout",
  "column_header.show_settings": "Zobrazit nastavení",
  "column_header.unpin": "Odepnout",
  "column_search.cancel": "Zrušit",
  "combobox.close_results": "Zavřít výsledky",
  "combobox.loading": "Načítání",
  "combobox.no_results_found": "Žádné výsledky pro toto vyhledávání",
  "combobox.open_results": "Otevřít výsledky",
  "combobox.results_available": "{count, plural, one {# doporučení} few {# doporučení} many {# doporučení} other {# doporučení}} k dispozici. Pro navigaci použijte šipky nahoru a dolů. Pro výběr stiskněte Enter.",
  "community.column_settings.local_only": "Pouze místní",
  "community.column_settings.media_only": "Pouze média",
  "community.column_settings.remote_only": "Pouze vzdálené",
  "compose.error.blank_post": "Příspěvek nemůže být prázdný.",
  "compose.language.change": "Změnit jazyk",
  "compose.language.search": "Prohledat jazyky...",
  "compose.published.body": "Příspěvek zveřejněn.",
  "compose.published.open": "Otevřít",
  "compose.saved.body": "Příspěvek uložen.",
  "compose_form.direct_message_warning_learn_more": "Zjistit více",
  "compose_form.encryption_warning": "Příspěvky na Mastodonu nejsou end-to-end šifrovány. Nesdílejte přes Mastodon žádné citlivé informace.",
  "compose_form.hashtag_warning": "Tento příspěvek nebude zobrazen pod žádným hashtagem, protože není veřejný. Podle hashtagu lze vyhledávat jen veřejné příspěvky.",
  "compose_form.lock_disclaimer": "Váš účet není {locked}. Kdokoliv vás může sledovat a vidět vaše příspěvky učené pouze pro sledující.",
  "compose_form.lock_disclaimer.lock": "zamčený",
  "compose_form.placeholder": "Co se vám honí hlavou?",
  "compose_form.poll.duration": "Doba trvání ankety",
  "compose_form.poll.multiple": "Výběr z více možností",
  "compose_form.poll.option_placeholder": "Volba {number}",
  "compose_form.poll.single": "Jediná volba",
  "compose_form.poll.switch_to_multiple": "Povolit u ankety výběr více voleb",
  "compose_form.poll.switch_to_single": "Povolit u ankety výběr pouze jedné volby",
  "compose_form.poll.type": "Styl",
  "compose_form.publish": "Odeslat",
  "compose_form.reply": "Odpovědět",
  "compose_form.save_changes": "Aktualizovat",
  "compose_form.spoiler.marked": "Odebrat varování o obsahu",
  "compose_form.spoiler.unmarked": "Přidat varování o obsahu",
  "compose_form.spoiler_placeholder": "Upozornění na obsah (nepovinné)",
  "confirmation_modal.cancel": "Zrušit",
  "confirmations.block.confirm": "Blokovat",
  "confirmations.delete.confirm": "Smazat",
  "confirmations.delete.message": "Opravdu chcete smazat tento příspěvek?",
  "confirmations.delete.title": "Smazat příspěvek?",
  "confirmations.delete_collection.confirm": "Smazat",
  "confirmations.delete_collection.message": "Tuto akci nelze vrátit zpět.",
  "confirmations.delete_collection.title": "Smazat „{name}“?",
  "confirmations.delete_list.confirm": "Smazat",
  "confirmations.delete_list.message": "Opravdu chcete tento seznam navždy smazat?",
  "confirmations.delete_list.title": "Smazat seznam?",
  "confirmations.discard_draft.confirm": "Zahodit a pokračovat",
  "confirmations.discard_draft.edit.cancel": "Pokračovat v úpravách",
  "confirmations.discard_draft.edit.message": "Pokračování zruší všechny změny, které jste provedli v příspěvku, který právě upravujete.",
  "confirmations.discard_draft.edit.title": "Zahodit změny ve vašem příspěvku?",
  "confirmations.discard_draft.post.cancel": "Obnovit koncept",
  "confirmations.discard_draft.post.message": "Pokračování zahodíte příspěvek, který právě tvoříte.",
  "confirmations.discard_draft.post.title": "Zahodit váš koncept příspěvku?",
  "confirmations.discard_edit_media.confirm": "Zahodit",
  "confirmations.discard_edit_media.message": "Máte neuložené změny popisku médií nebo náhledu, chcete je přesto zahodit?",
  "confirmations.follow_to_list.confirm": "Sledovat a přidat do seznamu",
  "confirmations.follow_to_list.message": "Musíte {name} sledovat, abyste je přidali do seznamu.",
  "confirmations.follow_to_list.title": "Sledovat uživatele?",
  "confirmations.hide_featured_tab.confirm": "Skrýt záložku",
  "confirmations.hide_featured_tab.intro": "Toto lze kdykoliv změnit v <i>Upravit profil > Nastavení záložky profilu</i>.",
  "confirmations.hide_featured_tab.message": "Toto skryje záložku uživatelům na {serverName} a ostatním serverům běžícím na poslední verzi Mastodonu. Ostatní zobrazení se mohou lišit.",
  "confirmations.hide_featured_tab.title": "Skrýt záložku \"Zvýrazněné\"?",
  "confirmations.logout.confirm": "Odhlásit se",
  "confirmations.logout.message": "Opravdu se chcete odhlásit?",
  "confirmations.logout.title": "Odhlásit se?",
  "confirmations.missing_alt_text.confirm": "Přidat popisek",
  "confirmations.missing_alt_text.message": "Váš příspěvek obsahuje média bez popisku. Jejich přidání pomáhá zpřístupnit váš obsah většímu počtu lidí.",
  "confirmations.missing_alt_text.secondary": "Přesto odeslat",
  "confirmations.missing_alt_text.title": "Přidat popisek?",
  "confirmations.mute.confirm": "Skrýt",
  "confirmations.private_quote_notify.cancel": "Zpět k úpravám",
  "confirmations.private_quote_notify.confirm": "Publikovat příspěvek",
  "confirmations.private_quote_notify.do_not_show_again": "Nezobrazujte mi znovu tuto zprávu",
  "confirmations.private_quote_notify.message": "Osoba, kterou citujete, a další zmínění budou upozorněni a budou moci si zobrazit váš příspěvek, i pokud vás nesledují.",
  "confirmations.private_quote_notify.title": "Sdílet se sledujícími a zmíněnými uživateli?",
  "confirmations.quiet_post_quote_info.dismiss": "Znovu nepřípomínat",
  "confirmations.quiet_post_quote_info.got_it": "Rozumím",
  "confirmations.quiet_post_quote_info.message": "Při citování ztišeného veřejného příspěvku, váš příspěvek bude skrytý z os populárních příspěvků.",
  "confirmations.quiet_post_quote_info.title": "Citování ztišených veřejných příspěvků",
  "confirmations.redraft.confirm": "Smazat a přepsat",
  "confirmations.redraft.message": "Jste si jistí, že chcete odstranit tento příspěvek a vytvořit z něj koncept? Oblíbené a boosty budou ztraceny a odpovědi na původní příspěvek ztratí kontext.",
  "confirmations.redraft.title": "Smazat a přepracovat příspěvek na koncept?",
  "confirmations.remove_from_followers.confirm": "Odstranit sledujícího",
  "confirmations.remove_from_followers.message": "{name} vás přestane sledovat. Jste si jisti, že chcete pokračovat?",
  "confirmations.remove_from_followers.title": "Odstranit sledujícího?",
  "confirmations.revoke_collection_inclusion.confirm": "Odebrat mě",
  "confirmations.revoke_collection_inclusion.message": "Správce vás nebude moci přidat do této kolekce po dobu 24 hodin. Pokud chcete natrvalo zabránit, aby vás přidával/a do kolekcí, můžete ho/ji zablokovat.",
  "confirmations.revoke_collection_inclusion.title": "Odstranit se z této kolekce?",
  "confirmations.revoke_quote.confirm": "Odstranit příspěvek",
  "confirmations.revoke_quote.message": "Tuto akci nelze vrátit zpět.",
  "confirmations.revoke_quote.title": "Odstranit příspěvek?",
  "confirmations.unblock.confirm": "Odblokovat",
  "confirmations.unblock.title": "Odblokovat {name}?",
  "confirmations.unfollow.confirm": "Přestat sledovat",
  "confirmations.unfollow.title": "Přestat sledovat {name}?",
  "confirmations.withdraw_request.confirm": "Zrušit žádost",
  "confirmations.withdraw_request.title": "Zrušit žádost na sledování {name}?",
  "content_warning.hide": "Skrýt příspěvek",
  "content_warning.show": "Přesto zobrazit",
  "content_warning.show_more": "Zobrazit více",
  "content_warning.show_short": "Zobrazit",
  "conversation.delete": "Smazat konverzaci",
  "conversation.mark_as_read": "Označit jako přečtené",
  "conversation.open": "Zobrazit konverzaci",
  "conversation.with": "S {names}",
  "copy_icon_button.copied": "Zkopírováno do schránky",
  "copy_icon_button.copy_this_text": "Zkopírovat odkaz do schránky",
  "copypaste.copied": "Zkopírováno",
  "copypaste.copy_to_clipboard": "Zkopírovat do schránky",
  "custom_homepage.about": "O serveru",
  "custom_homepage.about_this_server": "O tomto serveru",
  "custom_homepage.administered_by": "Server spravuje",
  "custom_homepage.contact": "Kontakt:",
  "custom_homepage.latest_activity": "Poslední aktivita",
  "custom_homepage.these_are_the_latest_posts": "Toto je posledních 40 příspěvků účtů z tohoto serveru.",
  "directory.federated": "Ze známého fediversu",
  "directory.local": "Pouze z {domain}",
  "directory.new_arrivals": "Nově příchozí",
  "directory.recently_active": "Nedávno aktivní",
  "disabled_account_banner.account_settings": "Nastavení účtu",
  "disabled_account_banner.text": "Váš účet {disabledAccount} je momentálně deaktivován.",
  "dismissable_banner.community_timeline": "Toto jsou nejnovější veřejné příspěvky od lidí, jejichž účty hostuje {domain}.",
  "dismissable_banner.dismiss": "Zavřít",
  "dismissable_banner.public_timeline": "Toto jsou nejnovější veřejné příspěvky od lidí na fediversu, které lidé na {domain} sledují.",
  "domain_block_modal.block": "Blokovat server",
  "domain_block_modal.block_account_instead": "Raději blokovat @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Lidé z tohoto serveru mohou interagovat s vašimi starými příspěvky.",
  "domain_block_modal.they_cant_follow": "Nikdo z tohoto serveru vás nemůže sledovat.",
  "domain_block_modal.they_wont_know": "Nebude vědět, že je zablokován*a.",
  "domain_block_modal.title": "Blokovat doménu?",
  "domain_block_modal.you_will_lose_num_followers": "Ztratíte {followersCount, plural, one {{followersCountDisplay} sledujícího} few {{followersCountDisplay} sledující} many {{followersCountDisplay} sledujících} other {{followersCountDisplay} sledujících}} a {followingCount, plural, one {{followingCountDisplay} sledovaného} few {{followingCountDisplay} sledované} many {{followingCountDisplay} sledovaných} other {{followingCountDisplay} sledovaných}}.",
  "domain_block_modal.you_will_lose_relationships": "Ztratíte všechny sledující a sledované z tohoto serveru.",
  "domain_block_modal.you_wont_see_posts": "Neuvidíte příspěvky ani upozornění od uživatelů z tohoto serveru.",
  "dropdown.empty": "Vyberte možnost",
  "email_subscriptions.email": "E-mail",
  "email_subscriptions.form.action": "Odebírat",
  "email_subscriptions.form.bottom": "Dostávejte příspěvky do své schránky bez vytváření účtu na Mastodonu. Lze se kdykoliv odhlásit. Další informace naleznete v <a>Zásadách ochrany osobních údajů</a>.",
  "email_subscriptions.form.title": "Přihlaste se k emailovým aktualizacím od {name}",
  "email_subscriptions.submitted.lead": "Zkontrolujte doručenou poštu pro dokončení přihlášení k emailovým aktualizacím.",
  "email_subscriptions.submitted.title": "Ještě jeden krok",
  "email_subscriptions.validation.email.blocked": "Blokovaný poskytovatel emailu",
  "email_subscriptions.validation.email.invalid": "Neplatná emailová adresa",
  "embed.instructions": "Pro přidání příspěvku na vaši webovou stránku zkopírujte níže uvedený kód.",
  "embed.preview": "Takhle to bude vypadat:",
  "emoji_button.activity": "Aktivita",
  "emoji_button.clear": "Vyčistit",
  "emoji_button.custom": "Vlastní",
  "emoji_button.flags": "Vlajky",
  "emoji_button.food": "Jídla a nápoje",
  "emoji_button.label": "Vložit emoji",
  "emoji_button.nature": "Příroda",
  "emoji_button.not_found": "Nebyly nalezeny žádné odpovídající emoji",
  "emoji_button.objects": "Předměty",
  "emoji_button.people": "Lidé",
  "emoji_button.recent": "Často používané",
  "emoji_button.search": "Hledat...",
  "emoji_button.search_results": "Výsledky hledání",
  "emoji_button.symbols": "Symboly",
  "emoji_button.travel": "Cestování a místa",
  "empty_column.account_featured.other": "{acct} zatím nic nezvýraznil/a.",
  "empty_column.account_featured_self.no_collections_button": "Vytvořit kolekci",
  "empty_column.account_featured_self.no_collections_hide_tab": "Raději tuto záložku skrýt",
  "empty_column.account_featured_self.showcase_accounts": "Představte své oblíbené účty",
  "empty_column.account_featured_self.showcase_accounts_desc": "Kolekce jsou spravované seznamy účtů, které pomáhají ostatním více objevovat Fediverse.",
  "empty_column.account_featured_unknown.other": "Tento účet zatím nic nezvýraznil.",
  "empty_column.account_hides_collections": "Tento uživatel se rozhodl tuto informaci nezveřejňovat",
  "empty_column.account_suspended": "Účet je pozastaven",
  "empty_column.account_timeline": "Nejsou tu žádné příspěvky!",
  "empty_column.account_unavailable": "Profil není dostupný",
  "empty_column.blocks": "Ještě jste nezablokovali žádného uživatele.",
  "empty_column.bookmarked_statuses": "Zatím v záložkách nemáte žádné příspěvky. Až si do nich nějaký přidáte, zobrazí se zde.",
  "empty_column.collections": "{acct} zatím nevytvořil/a žádné kolekce.",
  "empty_column.collections.featured_in": "Zatím jste nebyl/a do žádné kolekce přidán/a.",
  "empty_column.collections.featured_in_undiscoverable": "Aby vás mohli lidé přidat do sbírek, potřebujete povolit zvýrazňování ve vyhledávání pomocí <link>Předvolby > Soukromí a dosah</link>",
  "empty_column.collections_self": "Zatím jste nevytvořil/a žádnou kolekci.",
  "empty_column.community": "Místní časová osa je prázdná. Napište něco veřejně a rozhýbejte to tu!",
  "empty_column.direct": "Zatím nemáte žádné soukromé zmínky. Až nějakou pošlete nebo dostanete, zobrazí se zde.",
  "empty_column.disabled_feed": "Tento kanál byl zakázán administrátory vašeho serveru.",
  "empty_column.domain_blocks": "Ještě nemáte žádné zablokované domény.",
  "empty_column.explore_statuses": "Momentálně není nic populární. Vraťte se později!",
  "empty_column.favourited_statuses": "Zatím nemáte žádné oblíbené příspěvky. Až si nějaký oblíbíte, zobrazí se zde.",
  "empty_column.favourites": "Tento příspěvek si zatím nikdo neoblíbil. Až to někdo udělá, zobrazí se zde.",
  "empty_column.follow_requests": "Zatím nemáte žádné žádosti o sledování. Až nějakou obdržíte, zobrazí se zde.",
  "empty_column.followed_tags": "Zatím jste nesledovali žádné hashtagy. Až to uděláte, objeví se zde.",
  "empty_column.hashtag": "Pod tímto hashtagem zde zatím nic není.",
  "empty_column.home": "Vaše domovská časová osa je prázdná! Naplňte ji sledováním dalších lidí.",
  "empty_column.list": "V tomto seznamu zatím nic není. Až nějaký člen z tohoto seznamu zveřejní nový příspěvek, objeví se zde.",
  "empty_column.mutes": "Zatím jste neskryli žádného uživatele.",
  "empty_column.notification_requests": "Vyčištěno! Nic tu není. Jakmile obdržíš nové notifikace, objeví se zde podle tvého nastavení.",
  "empty_column.notifications": "Zatím nemáte žádná oznámení. Až s vámi někdo bude interagovat, uvidíte to zde.",
  "empty_column.public": "Tady nic není! Napište něco veřejně, nebo začněte ručně sledovat uživatele z jiných serverů, aby tu něco přibylo",
  "empty_state.no_results": "Žádné výsledky",
  "error.no_hashtag_feed_access": "Zaregistrujte se nebo se přihlaste k zobrazení a sledování tohoto hashtagu.",
  "error.unexpected_crash.explanation": "Kvůli chybě v našem kódu nebo problému s kompatibilitou prohlížeče nemohla být tato stránka správně zobrazena.",
  "error.unexpected_crash.explanation_addons": "Tuto stránku nelze správně zobrazit. Takovou chybu obvykle způsobuje doplněk prohlížeče nebo nástroje pro automatický překlad.",
  "error.unexpected_crash.next_steps": "Zkuste stránku načíst znovu. Pokud to nepomůže, zkuste Mastodon používat pomocí jiného prohlížeče nebo nativní aplikace.",
  "error.unexpected_crash.next_steps_addons": "Zkuste je vypnout a stránku obnovit. Pokud to nepomůže, zkuste otevřít Mastodon v jiném prohlížeči nebo nativní aplikaci.",
  "errors.unexpected_crash.copy_stacktrace": "Zkopírovat stacktrace do schránky",
  "errors.unexpected_crash.report_issue": "Nahlásit problém",
  "explore.suggested_follows": "Lidé",
  "explore.title": "Populární",
  "explore.trending_links": "Zprávy",
  "explore.trending_statuses": "Příspěvky",
  "explore.trending_tags": "Hashtagy",
  "featured_carousel.current": "<sr>Příspěvek</sr> {current, number}/{max, number}",
  "featured_carousel.header": "{count, plural, one {{counter} zvýrazněný příspěvek} few {{counter} zvýrazněné příspěvky} many {{counter} zvýrazněných příspěvků} other {{counter} zvýrazněných příspěvků}}",
  "featured_carousel.slide": "Příspěvek {current, number} z {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Nedávno jste napsal/a příspěvek o {items}. Přidat toto do zvýrazněných hashtagů?",
  "featured_tags.suggestions.add": "Přidat",
  "featured_tags.suggestions.added": "Spravujte své zvýrazněné hashtagy kdykoliv na <link>Upravit profil > Zvýrazněné hashtagy</link>.",
  "featured_tags.suggestions.dismiss": "Ne, děkuji",
  "filter_modal.added.context_mismatch_explanation": "Tato kategorie filtrů se nevztahuje na kontext, ve kterém jste tento příspěvek otevřeli. Pokud chcete, aby byl příspěvek filtrován i v tomto kontextu, budete muset filtr upravit.",
  "filter_modal.added.context_mismatch_title": "Kontext se neshoduje!",
  "filter_modal.added.expired_explanation": "Tato kategorie filtrů vypršela, budete muset změnit datum vypršení platnosti, aby mohla být použita.",
  "filter_modal.added.expired_title": "Platnost filtru vypršela!",
  "filter_modal.added.review_and_configure": "Chcete-li zkontrolovat a dále konfigurovat tuto kategorii filtrů, přejděte do {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Nastavení filtru",
  "filter_modal.added.settings_link": "stránka nastavení",
  "filter_modal.added.short_explanation": "Tento příspěvek byl přidán do následující kategorie filtrů: {title}.",
  "filter_modal.added.title": "Filtr byl přidán!",
  "filter_modal.select_filter.context_mismatch": "nevztahuje se na tento kontext",
  "filter_modal.select_filter.expired": "platnost vypršela",
  "filter_modal.select_filter.prompt_new": "Nová kategorie: {name}",
  "filter_modal.select_filter.search": "Vyhledat nebo vytvořit",
  "filter_modal.select_filter.subtitle": "Použít existující kategorii nebo vytvořit novou kategorii",
  "filter_modal.select_filter.title": "Filtrovat tento příspěvek",
  "filter_modal.title.status": "Filtrovat příspěvek",
  "filter_warning.matches_filter": "Odpovídá filtru “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "Od {count, plural, =0 {nikoho, koho možná znáte} one {člověka, kterého možná znáte} few {#, které možná znáte} many {#, které možná znáte} other {#, které možná znáte}}",
  "filtered_notifications_banner.title": "Filtrovaná oznámení",
  "firehose.all": "Vše",
  "firehose.local": "Tento server",
  "firehose.remote": "Ostatní servery",
  "follow_request.authorize": "Autorizovat",
  "follow_request.reject": "Zamítnout",
  "follow_requests.unlocked_explanation": "Přestože váš účet není uzamčen, personál {domain} usoudil, že byste mohli chtít tyto požadavky na sledování zkontrolovat ručně.",
  "follow_suggestions.curated_suggestion": "Výběr personálu",
  "follow_suggestions.dismiss": "Znovu nezobrazovat",
  "follow_suggestions.featured_longer": "Ručně vybráno týmem {domain}",
  "follow_suggestions.friends_of_friends_longer": "Populární mezi lidmi, které sledujete",
  "follow_suggestions.hints.featured": "Tento profil byl ručně vybrán týmem {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Tento profil je populární mezi lidmi, které sledujete.",
  "follow_suggestions.hints.most_followed": "Tento profil je jedním z nejsledovanějších na {domain}.",
  "follow_suggestions.hints.most_interactions": "Tomuto profilu se nedávno dostalo velké pozornosti na {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Tento profil je podobný profilům, které jste nedávno sledovali.",
  "follow_suggestions.personalized_suggestion": "Přizpůsobený návrh",
  "follow_suggestions.popular_suggestion": "Populární návrh",
  "follow_suggestions.popular_suggestion_longer": "Populární na {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Podobné profilům, které jste nedávno sledovali",
  "follow_suggestions.view_all": "Zobrazit vše",
  "follow_suggestions.who_to_follow": "Koho sledovat",
  "followed_tags": "Sledované hashtagy",
  "followers.hide_other_followers": "Tento uživatel se rozhodl nezveřejnit své další sledující",
  "followers.title": "Sledovat {name}",
  "following.hide_other_following": "Tento uživatel se rozhodl nezveřejnit seznam ostatních uživatelů, které sleduje",
  "following.title": "Sledován/a {name}",
  "footer.about": "O aplikaci",
  "footer.about_mastodon": "O Mastodonu",
  "footer.about_server": "O {domain}",
  "footer.about_this_server": "O serveru",
  "footer.directory": "Adresář profilů",
  "footer.get_app": "Získat aplikaci",
  "footer.keyboard_shortcuts": "Klávesové zkratky",
  "footer.privacy_policy": "Zásady ochrany osobních údajů",
  "footer.source_code": "Zobrazit zdrojový kód",
  "footer.status": "Stav",
  "footer.terms_of_service": "Obchodní podmínky",
  "form_error.blank": "Pole nemůže být prázdné.",
  "form_field.optional": "(volitelné)",
  "getting_started.heading": "Začínáme",
  "hashtag.admin_moderation": "Otevřít moderátorské rozhraní pro #{name}",
  "hashtag.browse": "Procházet příspěvky na #{hashtag}",
  "hashtag.browse_from_account": "Procházet příspěvky od @{name} v #{hashtag}",
  "hashtag.column_header.tag_mode.all": "a {additional}",
  "hashtag.column_header.tag_mode.any": "nebo {additional}",
  "hashtag.column_header.tag_mode.none": "bez {additional}",
  "hashtag.column_settings.select.no_options_message": "Nebyly nalezeny žádné návrhy",
  "hashtag.column_settings.select.placeholder": "Zadejte hashtagy…",
  "hashtag.column_settings.tag_mode.all": "Všechny z těchto",
  "hashtag.column_settings.tag_mode.any": "Jakýkoliv z těchto",
  "hashtag.column_settings.tag_mode.none": "Žádný z těchto",
  "hashtag.column_settings.tag_toggle": "Zahrnout v tomto sloupci další štítky",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} účastník*ice} few {{counter} účastníci} other {{counter} účastníků}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} příspěvek} few {{counter} příspěvky} other {{counter} příspěvků}}",
  "hashtag.counter_by_uses_today": "Dnes {count, plural, one {{counter} příspěvek} few {{counter} příspěvky} other {{counter} příspěvků}}",
  "hashtag.feature": "Zvýraznit na profilu",
  "hashtag.follow": "Sledovat hashtag",
  "hashtag.mute": "Skrýt #{hashtag}",
  "hashtag.unfeature": "Nezvýrazňovat na profilu",
  "hashtag.unfollow": "Přestat sledovat hashtag",
  "hashtags.and_other": "…a {count, plural, one {# další} few {# další} other {# dalších}}",
  "hints.profiles.followers_may_be_missing": "Sledující mohou pro tento profil chybět.",
  "hints.profiles.follows_may_be_missing": "Sledování mohou pro tento profil chybět.",
  "hints.profiles.posts_may_be_missing": "Některé příspěvky z tohoto profilu mohou chybět.",
  "hints.profiles.see_more_followers": "Zobrazit více sledujících na {domain}",
  "hints.profiles.see_more_follows": "Zobrazit další sledování na {domain}",
  "hints.profiles.see_more_posts": "Zobrazit další příspěvky na {domain}",
  "home.column_settings.show_quotes": "Zobrazit citace",
  "home.column_settings.show_reblogs": "Zobrazit boosty",
  "home.column_settings.show_replies": "Zobrazit odpovědi",
  "home.hide_announcements": "Skrýt oznámení",
  "home.pending_critical_update.body": "Aktualizujte, prosím, svůj Mastodon server co nejdříve!",
  "home.pending_critical_update.link": "Zobrazit aktualizace",
  "home.pending_critical_update.title": "K dispozici je kritická bezpečnostní aktualizace!",
  "home.show_announcements": "Zobrazit oznámení",
  "ignore_notifications_modal.bots_title": "Ignorovat oznámení od botů?",
  "ignore_notifications_modal.disclaimer": "Mastodon nemůže informovat uživatele, že jste ignorovali jejich oznámení. Ignorování oznámení nezabrání odesílání zpráv samotných.",
  "ignore_notifications_modal.filter_instead": "Místo toho filtrovat",
  "ignore_notifications_modal.filter_to_act_users": "Stále budete moci přijmout, odmítnout nebo nahlásit uživatele",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrování pomáhá vyhnout se možným nejasnostem",
  "ignore_notifications_modal.filter_to_review_separately": "Filtrovaná oznámení můžete zkontrolovat samostatně",
  "ignore_notifications_modal.ignore": "Ignorovat oznámení",
  "ignore_notifications_modal.limited_accounts_title": "Ignorovat oznámení z moderovaných účtů?",
  "ignore_notifications_modal.new_accounts_title": "Ignorovat oznámení z nových účtů?",
  "ignore_notifications_modal.not_followers_title": "Ignorovat oznámení od lidí, kteří vás nesledují?",
  "ignore_notifications_modal.not_following_title": "Ignorovat oznámení od lidí, které nesledujete?",
  "ignore_notifications_modal.private_mentions_title": "Ignorovat oznámení z nevyžádaných soukromých zmínek?",
  "info_button.label": "Nápověda",
  "info_button.what_is_alt_text": "<h1>Co je to alt text?</h1> <p>Alt text poskytuje popis obrázků pro lidi se zrakovými postižením, špatným připojením něbo těm, kteří potřebují více kontextu.</p> <p>Můžete zlepšit přístupnost a porozumění napsáním jasného, stručného a objektivního alt textu.</p> <ul> <li>Zachyťte důležité prvky</li> <li>Shrňte text v obrázku</li> <li>Použijte pravidelnou větnou skladbu</li> <li>Vyhněte se nadbytečným informacím</li> <li>U komplexních vizualizací (diagramy, mapy...) se zaměřte na trendy a klíčová zjištění</li> </ul>",
  "interaction_modal.action": "Chcete-li interagovat s příspěvkem {name}, budete se muset přihlásit do vašeho účtu na Mastodon serveru, který používáte.",
  "interaction_modal.action_follow": "Chcete-li sledovat {name}, musíte se přihlásit svým účtem z jakéhokoliv Mastodon serveru.",
  "interaction_modal.go": "Přejít",
  "interaction_modal.no_account_yet": "Ještě nemáte účet?",
  "interaction_modal.on_another_server": "Na jiném serveru",
  "interaction_modal.on_this_server": "Na tomto serveru",
  "interaction_modal.title": "Chcete-li pokračovat, přihlaste se",
  "interaction_modal.username_prompt": "např. {example}",
  "intervals.full.days": "{number, plural, one {# den} few {# dny} many {# dní} other {# dní}}",
  "intervals.full.hours": "{number, plural, one {# hodina} few {# hodiny} many {# hodin} other {# hodin}}",
  "intervals.full.minutes": "{number, plural, one {# minuta} few {# minuty} many {# minut} other {# minut}}",
  "keyboard_shortcuts.back": "Přejít zpět",
  "keyboard_shortcuts.blocked": "Otevřít seznam blokovaných uživatelů",
  "keyboard_shortcuts.boost": "Boostnout příspěvek",
  "keyboard_shortcuts.column": "Focus na sloupec",
  "keyboard_shortcuts.compose": "Zaměřit se na textové pole nového příspěvku",
  "keyboard_shortcuts.description": "Popis",
  "keyboard_shortcuts.direct": "Otevřít sloupec soukromých zmínek",
  "keyboard_shortcuts.down": "Posunout v seznamu dolů",
  "keyboard_shortcuts.enter": "Otevřít příspěvek",
  "keyboard_shortcuts.explore": "Otevřít trendovou časovou osu",
  "keyboard_shortcuts.favourite": "Oblíbit si příspěvek",
  "keyboard_shortcuts.favourites": "Otevřít seznam oblíbených",
  "keyboard_shortcuts.federated": "Otevřít federovanou časovou osu",
  "keyboard_shortcuts.heading": "Klávesové zkratky",
  "keyboard_shortcuts.home": "Otevřít domovskou časovou osu",
  "keyboard_shortcuts.hotkey": "Klávesová zkratka",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Backspace",
  "keyboard_shortcuts.keys.enter": "Enter",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Page Down",
  "keyboard_shortcuts.keys.page_up": "Page Up",
  "keyboard_shortcuts.legend": "Zobrazit tuto legendu",
  "keyboard_shortcuts.load_more": "Zvýraznit tlačítko „Načíst více“",
  "keyboard_shortcuts.local": "Otevřít místní časovou osu",
  "keyboard_shortcuts.mention": "Zmínit autora",
  "keyboard_shortcuts.muted": "Otevřít seznam skrytých uživatelů",
  "keyboard_shortcuts.my_profile": "Otevřít váš profil",
  "keyboard_shortcuts.notifications": "Otevřít sloupec oznámení",
  "keyboard_shortcuts.open_media": "Otevřít média",
  "keyboard_shortcuts.pinned": "Otevřít seznam připnutých příspěvků",
  "keyboard_shortcuts.profile": "Otevřít autorův profil",
  "keyboard_shortcuts.quote": "Citovat příspěvek",
  "keyboard_shortcuts.reply": "Odpovědět na příspěvek",
  "keyboard_shortcuts.requests": "Otevřít seznam žádostí o sledování",
  "keyboard_shortcuts.search": "Zaměřit se na vyhledávací lištu",
  "keyboard_shortcuts.spoilers": "Zobrazit/skrýt pole varování o obsahu",
  "keyboard_shortcuts.start": "Otevřít sloupec „začínáme“",
  "keyboard_shortcuts.toggle_hidden": "Zobrazit/skrýt text za varováním o obsahu",
  "keyboard_shortcuts.toggle_sensitivity": "Zobrazit/skrýt média",
  "keyboard_shortcuts.toot": "Začít nový příspěvek",
  "keyboard_shortcuts.top": "Přesunout na začátek seznamu",
  "keyboard_shortcuts.translate": "Přeložit příspěvek",
  "keyboard_shortcuts.unfocus": "Zrušit zaměření na nový příspěvek/hledání",
  "keyboard_shortcuts.up": "Posunout v seznamu nahoru",
  "learn_more_link.got_it": "Rozumím",
  "learn_more_link.learn_more": "Zjistit více",
  "lightbox.close": "Zavřít",
  "lightbox.next": "Další",
  "lightbox.previous": "Předchozí",
  "lightbox.zoom_in": "Přiblížit na skutečnou velikost",
  "lightbox.zoom_out": "Přizpůsobit velikost",
  "limited_account_hint.action": "Přesto profil zobrazit",
  "limited_account_hint.title": "Tento profil nebo server byl skryt moderátory {domain}.",
  "link_preview.author": "Od {name}",
  "link_preview.more_from_author": "Více od {name}",
  "link_preview.shares": "{count, plural, one {{counter} příspěvek} few {{counter} příspěvky} many {{counter} příspěvků} other {{counter} příspěvků}}",
  "lists.add_member": "Přidat",
  "lists.add_to_list": "Přidat do seznamu",
  "lists.add_to_lists": "Přidat {name} do seznamů",
  "lists.create": "Vytvořit",
  "lists.create_a_list_to_organize": "Vytvořte nový seznam pro organizaci vašeho domovského kanálu",
  "lists.create_list": "Vytvořit seznam",
  "lists.delete": "Smazat seznam",
  "lists.done": "Hotovo",
  "lists.edit": "Upravit seznam",
  "lists.exclusive": "Skrýt členy na domovském kanálu",
  "lists.exclusive_hint": "Pokud je někdo na tomto seznamu, skryjte jej ve vašem domovském kanálu, abyste se vyhnuli dvojímu vidění jejich příspěvků.",
  "lists.find_users_to_add": "Najít uživatele, které chcete přidat",
  "lists.list_members_count": "{count, plural, one {# člen} few {# členové} many {# členů} other {# členů}}",
  "lists.list_name": "Název seznamu",
  "lists.new_list_name": "Název nového seznamu",
  "lists.no_lists_yet": "Zatím žádné seznamy.",
  "lists.no_members_yet": "Zatím žádní členové.",
  "lists.no_results_found": "Nebyly nalezeny žádné výsledky.",
  "lists.remove_member": "Odstranit",
  "lists.replies_policy.followed": "Sledovaným uživatelům",
  "lists.replies_policy.list": "Členům seznamu",
  "lists.replies_policy.none": "Nikomu",
  "lists.save": "Uložit",
  "lists.search": "Hledat",
  "lists.show_replies_to": "Zahrnout odpovědi od členů seznamu pro",
  "load_pending": "{count, plural, one {# nová položka} few {# nové položky} many {# nových položek} other {# nových položek}}",
  "loading_indicator.label": "Načítání…",
  "media_gallery.hide": "Skrýt",
  "moved_to_account_banner.text": "Váš účet {disabledAccount} je momentálně deaktivován, protože jste se přesunul/a na {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Skrýt z oznámení",
  "mute_modal.hide_options": "Skrýt možnosti",
  "mute_modal.indefinite": "Dokud je neodeberu ze ztišených",
  "mute_modal.show_options": "Zobrazit možnosti",
  "mute_modal.they_can_mention_and_follow": "Mohou vás zmínit a sledovat, ale neuvidíte je.",
  "mute_modal.they_wont_know": "Nebudou vědět, že byli skryti.",
  "mute_modal.title": "Ztlumit uživatele*ku?",
  "mute_modal.you_wont_see_mentions": "Neuvidíte příspěvky, které je zmiňují.",
  "mute_modal.you_wont_see_posts": "Stále budou moci vidět vaše příspěvky, ale vy jejich neuvidíte.",
  "navigation_bar.about": "O aplikaci",
  "navigation_bar.account_settings": "Heslo a zabezpečení",
  "navigation_bar.administration": "Administrace",
  "navigation_bar.advanced_interface": "Otevřít v pokročilém webovém rozhraní",
  "navigation_bar.automated_deletion": "Automatické mazání příspěvků",
  "navigation_bar.blocks": "Blokovaní uživatelé",
  "navigation_bar.bookmarks": "Záložky",
  "navigation_bar.collections": "Kolekce",
  "navigation_bar.direct": "Soukromé zmínky",
  "navigation_bar.domain_blocks": "Blokované domény",
  "navigation_bar.favourites": "Oblíbené",
  "navigation_bar.filters": "Skrytá slova",
  "navigation_bar.follow_requests": "Žádosti o sledování",
  "navigation_bar.followed_tags": "Sledované hashtagy",
  "navigation_bar.follows_and_followers": "Sledovaní a sledující",
  "navigation_bar.import_export": "Import a export",
  "navigation_bar.lists": "Seznamy",
  "navigation_bar.live_feed_local": "Živý kanál (místní)",
  "navigation_bar.live_feed_public": "Živý kanál (veřejný)",
  "navigation_bar.logout": "Odhlásit se",
  "navigation_bar.main": "Hlavní menu",
  "navigation_bar.moderation": "Moderace",
  "navigation_bar.more": "Více",
  "navigation_bar.mutes": "Skrytí uživatelé",
  "navigation_bar.opened_in_classic_interface": "Příspěvky, účty a další specifické stránky jsou ve výchozím nastavení otevřeny v klasickém webovém rozhraní.",
  "navigation_bar.preferences": "Předvolby",
  "navigation_bar.privacy_and_reach": "Soukromí a dosah",
  "navigation_bar.search": "Hledat",
  "navigation_bar.search_trends": "Hledat / Populární",
  "navigation_panel.collapse_followed_tags": "Sbalit menu sledovaných hashtagů",
  "navigation_panel.collapse_lists": "Sbalit menu",
  "navigation_panel.expand_followed_tags": "Rozbalit menu sledovaných hashtagů",
  "navigation_panel.expand_lists": "Rozbalit menu",
  "not_signed_in_indicator.not_signed_in": "Pro přístup k tomuto zdroji se musíte přihlásit.",
  "notification.added_to_collection": "{name} vás přidal/a do kolekce",
  "notification.admin.report": "Uživatel {name} nahlásil {target}",
  "notification.admin.report_account": "{name} nahlásil {count, plural, one {jeden příspěvek} few {# příspěvky} many {# příspěvků} other {# příspěvků}} od {target} za {category}",
  "notification.admin.report_account_other": "{name} nahlásil {count, plural, one {jeden příspěvek} few {# příspěvky} many {# příspěvků} other {# příspěvků}} od {target}",
  "notification.admin.report_statuses": "{name} nahlásili {target} za {category}",
  "notification.admin.report_statuses_other": "{name} nahlásili {target}",
  "notification.admin.sign_up": "Uživatel {name} se zaregistroval",
  "notification.admin.sign_up.name_and_others": "{name} a {count, plural, one {# další} few {# další} many {# dalších} other {# dalších}} se zaregistrovali",
  "notification.annual_report.message": "Váš #Wrapstodon {year} na Vás čeká! Podívejte se, jak vypadal tento Váš rok na Mastodonu!",
  "notification.annual_report.view": "Zobrazit #Wrapstodon",
  "notification.collection_update": "{name} upravil kolekci, ve které se nacházíte",
  "notification.favourite": "{name} si oblíbil váš příspěvek",
  "notification.favourite.name_and_others_with_link": "{name} a {count, plural, one {<a># další</a> si oblíbil} few {<a># další</a> si oblíbili} other {<a># dalších</a> si oblíbilo}} Váš příspěvek",
  "notification.favourite_pm": "{name} si oblíbil vaši soukromou zmínku",
  "notification.favourite_pm.name_and_others_with_link": "{name} a {count, plural, one {<a># další</a> si oblíbil} few {<a># další</a> si oblíbili} other {<a># dalších</a> si oblíbilo}} Vaši soukromou zmínku",
  "notification.follow": "Uživatel {name} vás začal sledovat",
  "notification.follow.name_and_others": "{name} a {count, plural, one {<a># další</a> Vás začal sledovat} few {<a># další</a> Vás začali sledovat} other {<a># dalších</a> Vás začalo sledovat}}",
  "notification.follow_request": "Uživatel {name} požádal o povolení vás sledovat",
  "notification.follow_request.name_and_others": "{name} a {count, plural, one {# další Vám poslal žádost o sledování} few {# další Vám poslali žádost o sledování} other {# dalších Vám poslalo žádost o sledování}}",
  "notification.label.mention": "Zmínka",
  "notification.label.private_mention": "Soukromá zmínka",
  "notification.label.private_reply": "Privátní odpověď",
  "notification.label.quote": "{name} citovali váš příspěvek",
  "notification.label.reply": "Odpověď",
  "notification.mention": "Zmínka",
  "notification.mentioned_you": "{name} vás zmínil",
  "notification.moderation-warning.learn_more": "Zjistit více",
  "notification.moderation_warning": "Obdrželi jste varování od moderátorů",
  "notification.moderation_warning.action_delete_statuses": "Některé z vašich příspěvků byly odstraněny.",
  "notification.moderation_warning.action_disable": "Váš účet je zablokován.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Některé z vašich příspěvků byly označeny jako citlivé.",
  "notification.moderation_warning.action_none": "Váš účet obdržel varování od moderátorů.",
  "notification.moderation_warning.action_sensitive": "Vaše příspěvky budou od nynějška označeny jako citlivé.",
  "notification.moderation_warning.action_silence": "Váš účet byl omezen.",
  "notification.moderation_warning.action_suspend": "Váš účet byl pozastaven.",
  "notification.own_poll": "Vaše anketa skončila",
  "notification.poll": "Anketa, ve které jste hlasovali, skončila",
  "notification.quoted_update": "{name} upravili příspěvek, který jste citovali",
  "notification.reblog": "Uživatel {name} boostnul váš příspěvek",
  "notification.reblog.name_and_others_with_link": "{name} a {count, plural, one {<a># další</a> boostnul} few {<a># další</a> boostnuli} other {<a># dalších</a> boostnulo}} Váš příspěvek",
  "notification.relationships_severance_event": "Kontakt ztracen s {name}",
  "notification.relationships_severance_event.account_suspension": "Administrátor z {from} pozastavil {target}, což znamená, že již od nich nemůžete přijímat aktualizace nebo s nimi interagovat.",
  "notification.relationships_severance_event.domain_block": "Administrátor z {from} pozastavil {target}, včetně {followersCount} z vašich sledujících a {followingCount, plural, one {# účet, který sledujete} few {# účty, které sledujete} many {# účtů, které sledujete} other {# účtů, které sledujete}}.",
  "notification.relationships_severance_event.learn_more": "Zjistit více",
  "notification.relationships_severance_event.user_domain_block": "Zablokovali jste {target}, čímž jste odebrali {followersCount} z vašich sledujících a {followingCount, plural, one {# účet, který sledujete} few {# účty, které sledujete} many {# účtů, které sledujete} other {# účtů, které sledujete}}.",
  "notification.status": "Uživatel {name} právě přidal příspěvek",
  "notification.update": "Uživatel {name} upravil příspěvek",
  "notification_requests.accept": "Přijmout",
  "notification_requests.accept_multiple": "{count, plural, one {Schválit # požadavek…} few {Schválit # požadavky…} other {Schválit # požadavků…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Schválit požadavek} other {Schválit požadavky}}",
  "notification_requests.confirm_accept_multiple.message": "Chystáte se schválit {count, plural, one {jeden požadavek} few {# požadavky} other {# požadavků}} na oznámení. Opravdu chcete pokračovat?",
  "notification_requests.confirm_accept_multiple.title": "Přijmout žádosti o oznámení?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Zamítnout požadavek} other {Zamítnout požadavky}}",
  "notification_requests.confirm_dismiss_multiple.message": "Chystáte se zamítnout {count, plural, one {jeden požadavek} few {# požadavky} many {# požadavků} other {# požadavků}} na oznámení. Poté k {count, plural, one {němu} other {něm}} již nebudete mít snadný přístup. Opravdu chcete pokračovat?",
  "notification_requests.confirm_dismiss_multiple.title": "Zamítnout požadavky na oznámení?",
  "notification_requests.dismiss": "Zamítnout",
  "notification_requests.dismiss_multiple": "Zamítnout {count, plural, one {# požadavek} few {# požadavky} many {# požadavků} other {# požadavků}}…",
  "notification_requests.edit_selection": "Upravit",
  "notification_requests.exit_selection": "Hotovo",
  "notification_requests.explainer_for_limited_account": "Oznámení z tohoto účtu byla filtrována, protože tento účet byl omezen moderátorem.",
  "notification_requests.explainer_for_limited_remote_account": "Oznámení z tohoto účtu byla filtrována, protože tento účet nebo jeho server byl omezen moderátorem.",
  "notification_requests.maximize": "Maximalizovat",
  "notification_requests.minimize_banner": "Minimalizovat banner filtrovaných oznámení",
  "notification_requests.notifications_from": "Oznámení od {name}",
  "notification_requests.title": "Filtrovaná oznámení",
  "notification_requests.view": "Zobrazit oznámení",
  "notifications.clear": "Vyčistit oznámení",
  "notifications.clear_confirmation": "Opravdu chcete trvale smazat všechna vaše oznámení?",
  "notifications.clear_title": "Vyčistit oznámení?",
  "notifications.column_settings.admin.report": "Nová hlášení:",
  "notifications.column_settings.admin.sign_up": "Nové registrace:",
  "notifications.column_settings.alert": "Oznámení na počítači",
  "notifications.column_settings.collections": "Kolekce:",
  "notifications.column_settings.favourite": "Oblíbené:",
  "notifications.column_settings.filter_bar.advanced": "Zobrazit všechny kategorie",
  "notifications.column_settings.filter_bar.category": "Panel rychlého filtrování",
  "notifications.column_settings.follow": "Noví sledující:",
  "notifications.column_settings.follow_request": "Nové žádosti o sledování:",
  "notifications.column_settings.group": "Skupina",
  "notifications.column_settings.mention": "Zmínky:",
  "notifications.column_settings.poll": "Výsledky anket:",
  "notifications.column_settings.push": "Push oznámení",
  "notifications.column_settings.quote": "Citace:",
  "notifications.column_settings.reblog": "Boosty:",
  "notifications.column_settings.show": "Zobrazit ve sloupci",
  "notifications.column_settings.sound": "Přehrát zvuk",
  "notifications.column_settings.status": "Nové příspěvky:",
  "notifications.column_settings.unread_notifications.category": "Nepřečtená oznámení",
  "notifications.column_settings.unread_notifications.highlight": "Zvýraznit nepřečtená oznámení",
  "notifications.column_settings.update": "Úpravy:",
  "notifications.filter.all": "Vše",
  "notifications.filter.boosts": "Boosty",
  "notifications.filter.collections": "Kolekce",
  "notifications.filter.favourites": "Oblíbené",
  "notifications.filter.follows": "Sledování",
  "notifications.filter.mentions": "Zmínky",
  "notifications.filter.polls": "Výsledky anket",
  "notifications.filter.statuses": "Aktualizace od lidí, které sledujete",
  "notifications.grant_permission": "Udělit oprávnění.",
  "notifications.group": "{count} oznámení",
  "notifications.mark_as_read": "Označit všechna oznámení jako přečtená",
  "notifications.permission_denied": "Oznámení na ploše nejsou k dispozici, protože byla zamítnuta žádost o oprávnění je zobrazovat",
  "notifications.permission_denied_alert": "Oznámení na ploše není možné zapnout, protože oprávnění bylo v minulosti zamítnuto",
  "notifications.permission_required": "Oznámení na ploše nejsou k dispozici, protože nebylo uděleno potřebné oprávnění.",
  "notifications.policy.accept": "Přijmout",
  "notifications.policy.accept_hint": "Zobrazit v oznámeních",
  "notifications.policy.drop": "Ignorovat",
  "notifications.policy.drop_hint": "Permanentně odstranit, aby již nikdy nespatřil světlo světa",
  "notifications.policy.filter": "Filtrovat",
  "notifications.policy.filter_bots_hint": "Účty označeny jako automatizované",
  "notifications.policy.filter_bots_title": "Boti",
  "notifications.policy.filter_hint": "Odeslat do filtrované schránky oznámení",
  "notifications.policy.filter_limited_accounts_hint": "Omezeno moderátory serveru",
  "notifications.policy.filter_limited_accounts_title": "Moderované účty",
  "notifications.policy.filter_new_accounts.hint": "Vytvořeno během {days, plural, one {včerejška} few {posledních # dnů} many {posledních # dní} other {posledních # dní}}",
  "notifications.policy.filter_new_accounts_title": "Nové účty",
  "notifications.policy.filter_not_followers_hint": "Včetně lidí, kteří vás sledovali méně než {days, plural, one {jeden den} few {# dny} many {# dní} other {# dní}}",
  "notifications.policy.filter_not_followers_title": "Lidé, kteří vás nesledují",
  "notifications.policy.filter_not_following_hint": "Dokud je ručně neschválíte",
  "notifications.policy.filter_not_following_title": "Lidé, které nesledujete",
  "notifications.policy.filter_private_mentions_hint": "Filtrováno, pokud to není v odpovědi na vaši vlastní zmínku nebo pokud nesledujete odesílatele",
  "notifications.policy.filter_private_mentions_title": "Nevyžádané soukromé zmínky",
  "notifications.policy.title": "Spravovat oznámení od…",
  "notifications_permission_banner.enable": "Povolit oznámení na ploše",
  "notifications_permission_banner.how_to_control": "Chcete-li dostávat oznámení, i když nemáte Mastodon otevřený, povolte oznámení na ploše. Můžete si zvolit, o kterých druzích interakcí chcete být oznámením na ploše informování pod tlačítkem {icon} výše.",
  "notifications_permission_banner.title": "Nenechte si nic uniknout",
  "onboarding.follows.back": "Zpět",
  "onboarding.follows.empty": "Bohužel, žádné výsledky nelze momentálně zobrazit. Můžete zkusit najít uživatele ke sledování za pomocí vyhledávání nebo na stránce „Objevit“, nebo to zkuste znovu později.",
  "onboarding.follows.next": "Dále: Nastavte si profil",
  "onboarding.follows.search": "Hledat",
  "onboarding.follows.title": "Sledujte lidi a začněte",
  "onboarding.profile.discoverable": "Udělat svůj profil vyhledatelným",
  "onboarding.profile.discoverable_hint": "Když se rozhodnete být vyhledatelný na Mastodonu, vaše příspěvky se mohou objevit ve výsledcích vyhledávání a v populárních, a váš profil může být navrhován lidem s podobnými zájmy.",
  "onboarding.profile.display_name": "Zobrazované jméno",
  "onboarding.profile.display_name_hint": "Vaše celé jméno nebo přezdívka…",
  "onboarding.profile.finish": "Dokončit",
  "onboarding.profile.note": "O vás",
  "onboarding.profile.note_hint": "Můžete @zmínit jiné osoby nebo #hashtagy…",
  "onboarding.profile.title": "Nastavení profilu",
  "onboarding.profile.upload_avatar": "Nahrát profilový obrázek",
  "onboarding.profile.upload_header": "Nahrát hlavičku profilu",
  "password_confirmation.exceeds_maxlength": "Potvrzení hesla překračuje maximální povolenou délku",
  "password_confirmation.mismatching": "Zadaná hesla se neshodují",
  "picture_in_picture.restore": "Vrátit zpět",
  "poll.closed": "Uzavřeno",
  "poll.refresh": "Obnovit",
  "poll.reveal": "Zobrazit výsledky",
  "poll.total_people": "{count, plural, one {# člověk} few {# lidé} many {# lidí} other {# lidí}}",
  "poll.total_votes": "{count, plural, one {# hlas} few {# hlasy} many {# hlasů} other {# hlasů}}",
  "poll.vote": "Hlasovat",
  "poll.voted": "Hlasovali jste pro tuto odpověď",
  "poll.votes": "{votes, plural, one {# hlas} few {# hlasy} many {# hlasů} other {# hlasů}}",
  "poll_button.add_poll": "Přidat anketu",
  "poll_button.remove_poll": "Odebrat anketu",
  "privacy.change": "Změnit soukromí příspěvku",
  "privacy.direct.long": "Všichni zmínění v příspěvku",
  "privacy.direct.short": "Soukromá zmínka",
  "privacy.private.long": "Jen vaši sledující",
  "privacy.private.short": "Sledující",
  "privacy.public.long": "Kdokoliv na Mastodonu i mimo něj",
  "privacy.public.short": "Veřejné",
  "privacy.quote.anyone": "{visibility}, citování povoleno",
  "privacy.quote.disabled": "{visibility}, citování je zakázáno",
  "privacy.quote.limited": "{visibility}, citování je omezené",
  "privacy.unlisted.additional": "Chová se stejně jako veřejný, až na to, že se příspěvek neobjeví v živých kanálech nebo hashtazích, v objevování nebo vyhledávání na Mastodonu, a to i když je účet nastaven tak, aby se zde všude tyto příspěvky zobrazovaly.",
  "privacy.unlisted.long": "Skryté z výsledků vyhledávání na Mastodonu, trendujících příspěvků a veřejné časové osy",
  "privacy.unlisted.short": "Ztišené veřejné",
  "privacy_policy.last_updated": "Naposledy aktualizováno {date}",
  "privacy_policy.title": "Zásady ochrany osobních údajů",
  "quote_error.edit": "Citáty nemohou být přidány při úpravě příspěvku.",
  "quote_error.poll": "Citování není u dotazníků povoleno.",
  "quote_error.private_mentions": "Citování není povoleno s přímými zmínkami.",
  "quote_error.quote": "Je povoleno citovat pouze jednou.",
  "quote_error.unauthorized": "Nemáte oprávnění citovat tento příspěvek.",
  "quote_error.upload": "Není povoleno citovat s přílohami.",
  "recommended": "Doporučeno",
  "refresh": "Obnovit",
  "regeneration_indicator.please_stand_by": "Počkej prosím.",
  "regeneration_indicator.preparing_your_home_feed": "Připravujeme vaší domovskou stránku…",
  "relative_time.days": "{number} d",
  "relative_time.full.days": "před {number, plural, one {# dnem} few {# dny} many {# dny} other {# dny}}",
  "relative_time.full.hours": "před {number, plural, one {# hodinou} few {# hodinami} many {# hodinami} other {# hodinami}}",
  "relative_time.full.just_now": "právě teď",
  "relative_time.full.minutes": "před {number, plural, one {# minutou} few {# minutami} many {# minutami} other {# minutami}}",
  "relative_time.full.seconds": "před {number, plural, one {# sekundou} few {# sekundami} many {# sekundami} other {# sekundami}}",
  "relative_time.hours": "{number} h",
  "relative_time.just_now": "teď",
  "relative_time.minutes": "{number} m",
  "relative_time.seconds": "{number} s",
  "relative_time.today": "dnes",
  "remove_quote_hint.button_label": "Chápu",
  "remove_quote_hint.message": "Můžete to udělat z {icon} nabídky možností.",
  "remove_quote_hint.title": "Chcete odstranit citovaný příspěvek?",
  "reply_indicator.attachments": "{count, plural, one {{counter} příloha} few {{counter} přílohy} other {{counter} příloh}}",
  "reply_indicator.cancel": "Zrušit",
  "reply_indicator.poll": "Anketa",
  "report.block": "Blokovat",
  "report.block_explanation": "Neuvidíte příspěvky tohoto uživatele. On neuvidí vaše příspěvky, ani vás nebude moci sledovat. Pozná, že je blokován.",
  "report.categories.legal": "Právní ustanovení",
  "report.categories.other": "Ostatní",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Obsah porušuje jedno nebo více pravidel serveru",
  "report.category.subtitle": "Vyberte nejbližší možnost",
  "report.category.title_account": "Povězte nám, co se děje s tímto profilem",
  "report.category.title_collection": "Povězte nám, co se děje s touto kolekcí",
  "report.category.title_status": "Povězte nám, co se děje s tímto příspěvkem",
  "report.close": "Hotovo",
  "report.comment.title": "Je ještě něco jiného, co myslíte, že bychom měli vědět?",
  "report.forward": "Přeposlat do {target}",
  "report.forward_hint": "Tento účet je z jiného serveru. Chcete na něj také poslat anonymizovanou kopii hlášení?",
  "report.mute": "Skrýt",
  "report.mute_explanation": "Neuvidíte příspěvky tohoto uživatele. On vás může nadále sledovat i vidět vaše příspěvky a nebude vědět, že je skryt.",
  "report.next": "Další",
  "report.placeholder": "Další komentáře",
  "report.reasons.dislike": "Nelíbí se mi to",
  "report.reasons.dislike_description": "Není to něco, co chcete vidět",
  "report.reasons.legal": "Je to nezákonné",
  "report.reasons.legal_description": "Domníváte se, že to porušuje zákony vaší země nebo země serveru",
  "report.reasons.other": "Je to něco jiného",
  "report.reasons.other_description": "Problém neodpovídá ostatním kategoriím",
  "report.reasons.spam": "Je to spam",
  "report.reasons.spam_description": "Škodlivé odkazy, falešné interakce nebo opakované odpovědi",
  "report.reasons.violation": "Porušuje to pravidla serveru",
  "report.reasons.violation_description": "Máte za to, že to porušuje konkrétní pravidla",
  "report.rules.subtitle": "Vyberte všechna relevantní",
  "report.rules.title": "Která pravidla to porušuje?",
  "report.statuses.subtitle": "Vyberte všechny relevantní",
  "report.statuses.title": "Existují příspěvky dokládající toto hlášení?",
  "report.submission_error": "Nahlášení nelze odeslat",
  "report.submission_error_details": "Zkontrolujte připojení k síti a opakujte akci později.",
  "report.submit": "Odeslat",
  "report.target": "Nahlašování uživatele {target}",
  "report.thanks.take_action": "Tady jsou vaše možnosti pro řízení toho, co na Mastodonu vidíte:",
  "report.thanks.take_action_actionable": "Zatímco to posuzujeme, můžete podniknout akce proti @{name}:",
  "report.thanks.title": "Nechcete tohle vidět?",
  "report.thanks.title_actionable": "Děkujeme za nahlášení, podíváme se na to.",
  "report.unfollow": "Přestat sledovat @{name}",
  "report.unfollow_explanation": "Tento účet sledujete. Abyste už neviděli jeho příspěvky ve své domovské časové ose, přestaňte jej sledovat.",
  "report_notification.attached_statuses": "{count, plural, one {{count} připojený příspěvek} few {{count} připojené příspěvky} many {{count} připojených příspěvků} other {{count} připojených příspěvků}}",
  "report_notification.categories.legal": "Právní ustanovení",
  "report_notification.categories.legal_sentence": "nezákonný obsah",
  "report_notification.categories.other": "Ostatní",
  "report_notification.categories.other_sentence": "další",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Porušení pravidla",
  "report_notification.categories.violation_sentence": "porušení pravidel",
  "report_notification.open": "Otevřít hlášení",
  "search.clear": "Vymazat hledání",
  "search.no_recent_searches": "Žádná nedávná vyhledávání",
  "search.placeholder": "Hledat",
  "search.quick_action.account_search": "Profily odpovídající {x}",
  "search.quick_action.go_to_account": "Přejít na profil {x}",
  "search.quick_action.go_to_hashtag": "Přejít na hashtag {x}",
  "search.quick_action.open_url": "Otevřít URL v Mastodonu",
  "search.quick_action.status_search": "Příspěvky odpovídající {x}",
  "search.search_or_paste": "Hledat nebo vložit URL",
  "search_popout.full_text_search_disabled_message": "Nedostupné na {domain}.",
  "search_popout.full_text_search_logged_out_message": "Dostupné pouze po přihlášení.",
  "search_popout.language_code": "ISO kód jazyka",
  "search_popout.options": "Možnosti hledání",
  "search_popout.quick_actions": "Rychlé akce",
  "search_popout.recent": "Nedávná vyhledávání",
  "search_popout.specific_date": "konkrétní datum",
  "search_popout.user": "uživatel",
  "search_results.accounts": "Profily",
  "search_results.all": "Vše",
  "search_results.collections": "Kolekce",
  "search_results.hashtags": "Hashtagy",
  "search_results.no_results": "Nelze najít.",
  "search_results.no_search_yet": "Zkuste vyhledat příspěvky, profily nebo hashtagy.",
  "search_results.see_all": "Zobrazit vše",
  "search_results.statuses": "Příspěvky",
  "search_results.title": "Hledat \"{q}\"",
  "server_banner.about_active_users": "Lidé používající tento server během posledních 30 dní (měsíční aktivní uživatelé)",
  "server_banner.active_users": "aktivní uživatelé",
  "server_banner.administered_by": "Spravováno:",
  "server_banner.is_one_of_many": "{domain} je jedním z mnoha Mastodon serverů, které můžete použít k účasti na fediversu.",
  "server_banner.more_about_this_server": "Více o tomto serveru",
  "server_banner.server_stats": "Statistiky serveru:",
  "sign_in_banner.create_account": "Vytvořit účet",
  "sign_in_banner.follow_anyone": "Sledujte kohokoli napříč fediversem a uvidíte vše v chronologickém pořadí. Bez algoritmů, reklam a clickbaitu.",
  "sign_in_banner.mastodon_is": "Mastodon je ten nejlepší způsob, jak udržet krok s tím, co se právě děje.",
  "sign_in_banner.sign_in": "Přihlásit se",
  "sign_in_banner.sso_redirect": "Přihlášení nebo Registrace",
  "skip_links.hotkey": "<span>Klávesová zkratka</span> {hotkey}",
  "skip_links.skip_to_content": "Přejít na hlavní obsah",
  "skip_links.skip_to_navigation": "Přejít na hlavní navigaci",
  "status.admin_account": "Otevřít moderátorské rozhraní pro @{name}",
  "status.admin_domain": "Otevřít moderátorské rozhraní pro {domain}",
  "status.admin_status": "Otevřít tento příspěvek v moderátorském rozhraní",
  "status.all_disabled": "Boosty a citace jsou zakázány",
  "status.block": "Blokovat @{name}",
  "status.bookmark": "Přidat do záložek",
  "status.cancel_reblog_private": "Zrušit boostnutí",
  "status.cannot_quote": "Nemáte oprávnění citovat tento příspěvek",
  "status.cannot_reblog": "Tento příspěvek nemůže být boostnutý",
  "status.contains_quote": "Obsahuje citaci",
  "status.context.loading": "Načítání dalších odpovědí",
  "status.context.loading_error": "Nelze načíst nové odpovědi",
  "status.context.loading_success": "Nové odpovědi načteny",
  "status.context.more_replies_found": "Nalezeny další odpovědi",
  "status.context.retry": "Zkusit znovu",
  "status.context.show": "Zobrazit",
  "status.continued_thread": "Pokračuje ve vlákně",
  "status.copy": "Zkopírovat odkaz na příspěvek",
  "status.delete": "Smazat",
  "status.delete.success": "Příspěvek byl smazán",
  "status.detailed_status": "Podrobné zobrazení konverzace",
  "status.direct": "Soukromě zmínit @{name}",
  "status.direct_indicator": "Soukromá zmínka",
  "status.edit": "Upravit",
  "status.edited": "Naposledy upraveno {date}",
  "status.edited_x_times": "Upraveno {count, plural, one {{count}krát} few {{count}krát} many {{count}krát} other {{count}krát}}",
  "status.embed": "Získejte kód pro vložení",
  "status.favourite": "Oblíbit",
  "status.favourites_count": "{count, plural, one {{counter} oblíbený} few {{counter} oblíbené} many {{counter} oblíbených} other {{counter} oblíbených}}",
  "status.filter": "Filtrovat tento příspěvek",
  "status.history.created": "Uživatel {name} vytvořil {date}",
  "status.history.edited": "Uživatel {name} upravil {date}",
  "status.load_more": "Načíst více",
  "status.media.open": "Kliknutím otevřete",
  "status.media.show": "Kliknutím zobrazíte",
  "status.media_hidden": "Média jsou skryta",
  "status.mention": "Zmínit @{name}",
  "status.more": "Více",
  "status.mute": "Skrýt @{name}",
  "status.mute_conversation": "Skrýt konverzaci",
  "status.open": "Rozbalit tento příspěvek",
  "status.pin": "Připnout na profil",
  "status.quote": "Citovat",
  "status.quote.cancel": "Zrušit citování",
  "status.quote_error.blocked_account_hint.title": "Tento příspěvek je skryt, protože jste zablokovali @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Tento příspěvek je skryt, protože jste zablokovali {domain}.",
  "status.quote_error.filtered": "Skryté kvůli jednomu z vašich filtrů",
  "status.quote_error.limited_account_hint.action": "Přesto zobrazit",
  "status.quote_error.limited_account_hint.title": "Tento účet byl skryt moderátory {domain}.",
  "status.quote_error.muted_account_hint.title": "Tento příspěvek je skryt, protože jste ztišili @{name}.",
  "status.quote_error.not_available": "Příspěvek není dostupný",
  "status.quote_error.pending_approval": "Příspěvek čeká na schválení",
  "status.quote_error.pending_approval_popout.body": "Na Mastodonu můžete kontrolovat, zda vás někdo může citovat. Tento příspěvek čeká, dokud neobdržíme schválení od původního autora.",
  "status.quote_error.revoked": "Příspěvek odstraněn autorem",
  "status.quote_followers_only": "Pouze moji sledující mohou citovat tento příspěvek",
  "status.quote_manual_review": "Autor provede manuální kontrolu",
  "status.quote_noun": "Citace",
  "status.quote_policy_change": "Změňte, kdo může citovat",
  "status.quote_post_author": "Citovali příspěvek od @{name}",
  "status.quote_private": "Soukromé příspěvky nelze citovat",
  "status.quotes.empty": "Tento příspěvek zatím nikdo necitoval. Pokud tak někdo učiní, uvidíte to zde.",
  "status.quotes.local_other_disclaimer": "Citace zamítnuté autorem nebudou zobrazeny.",
  "status.quotes.remote_other_disclaimer": "Pouze citace z {domain} zde budou zaručeně ukázány. Citace zamítnuté autorem nebudou zobrazeny.",
  "status.quotes_count": "{count, plural, one {{counter} citace} few {{counter} citace} many {{counter} citací} other {{counter} citací}}",
  "status.read_more": "Číst více",
  "status.reblog": "Boostnout",
  "status.reblog_or_quote": "Boostnout nebo citovat",
  "status.reblog_private": "Sdílejte znovu se svými sledujícími",
  "status.reblogged_by": "Uživatel {name} boostnul",
  "status.reblogs.empty": "Tento příspěvek ještě nikdo neboostnul. Pokud to někdo udělá, zobrazí se zde.",
  "status.reblogs_count": "{count, plural, one {{counter} boost} few {{counter} boosty} many {{counter} boostů} other {{counter} boostů}}",
  "status.redraft": "Smazat a přepsat",
  "status.remove_bookmark": "Odstranit ze záložek",
  "status.remove_favourite": "Odebrat z oblíbených",
  "status.remove_quote": "Odstranit",
  "status.replied_in_thread": "Odpověděli ve vlákně",
  "status.replied_to": "Odpověděl/a uživateli {name}",
  "status.reply": "Odpovědět",
  "status.replyAll": "Odpovědět na vlákno",
  "status.report": "Nahlásit @{name}",
  "status.request_quote": "Požádat o možnost citovat",
  "status.revoke_quote": "Odstranit můj příspěvek z příspěvku @{name}",
  "status.sensitive_warning": "Citlivý obsah",
  "status.share": "Sdílet",
  "status.show_less_all": "Zobrazit méně pro všechny",
  "status.show_more_all": "Zobrazit více pro všechny",
  "status.show_original": "Zobrazit originál",
  "status.title.with_attachments": "{user} zveřejnil {attachmentCount, plural, one {přílohu} few {{attachmentCount} přílohy} many {{attachmentCount} příloh} other {{attachmentCount} příloh}}",
  "status.translate": "Přeložit",
  "status.translated_from_with": "Přeloženo z {lang} pomocí {provider}",
  "status.uncached_media_warning": "Náhled není k dispozici",
  "status.unmute_conversation": "Zrušit skrytí konverzace",
  "status.unpin": "Odepnout z profilu",
  "subscribed_languages.lead": "Ve vašem domovském kanálu a časových osách se po změně budou objevovat pouze příspěvky ve vybraných jazycích. Pro příjem příspěvků ve všech jazycích nevyberte žádný jazyk.",
  "subscribed_languages.save": "Uložit změny",
  "subscribed_languages.target": "Změnit odebírané jazyky na {target}",
  "tabs_bar.home": "Domů",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Oznámení",
  "tabs_bar.publish": "Nový příspěvek",
  "tabs_bar.quick_links": "Rychlé odkazy",
  "tabs_bar.search": "Vyhledávání",
  "tag.remove": "Odebrat",
  "terms_of_service.effective_as_of": "Platné od {date}",
  "terms_of_service.title": "Podmínky služby",
  "terms_of_service.upcoming_changes_on": "Nadcházející změny v {date}",
  "time_remaining.days": "{number, plural, one {Zbývá # den} few {Zbývají # dny} many {Zbývá # dní} other {Zbývá # dní}}",
  "time_remaining.hours": "{number, plural, one {Zbývá # hodina} few {Zbývají # hodiny} many {Zbývá # hodin} other {Zbývá # hodin}}",
  "time_remaining.minutes": "{number, plural, one {Zbývá # minuta} few {Zbývají # minuty} many {Zbývá # minut} other {Zbývá # minut}}",
  "time_remaining.moments": "Zbývá několik sekund",
  "time_remaining.seconds": "{number, plural, one {Zbývá # sekunda} few {Zbývají # sekundy} many {Zbývá # sekund} other {Zbývá # sekund}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} člověk} few {{counter} lidé} many {{counter} lidí} other {{counter} lidí}} za poslední {days, plural, one {den} few {{days} dny} many {{days} dnů} other {{days} dnů}}",
  "trends.trending_now": "Právě populární",
  "ui.beforeunload": "Pokud Mastodon opustíte, váš koncept se ztratí.",
  "units.short.billion": "{count} mld.",
  "units.short.million": "{count} mil.",
  "units.short.thousand": "{count} tis.",
  "upload_area.title": "Nahrajte přetažením",
  "upload_button.label": "Přidat obrázky, video nebo audio soubor",
  "upload_error.limit": "Byl překročen limit nahraných souborů.",
  "upload_error.poll": "Nahrávání souborů není povoleno s anketami.",
  "upload_error.quote": "Nahrávání souboru není povoleno s citacemi.",
  "upload_form.drag_and_drop.instructions": "Chcete-li zvednout přílohu, stiskněte mezerník nebo enter. Při přetažení použijte klávesnicové šipky k přesunutí mediální přílohy v libovolném směru. Stiskněte mezerník nebo enter pro vložení přílohy do nové pozice, nebo stiskněte Esc pro ukončení.",
  "upload_form.drag_and_drop.on_drag_cancel": "Přetažení bylo zrušeno. Příloha {item} byla vrácena.",
  "upload_form.drag_and_drop.on_drag_end": "Příloha {item} byla vrácena.",
  "upload_form.drag_and_drop.on_drag_over": "Příloha {item} byla přesunuta.",
  "upload_form.drag_and_drop.on_drag_start": "Zvednuta příloha {item}.",
  "upload_form.edit": "Upravit",
  "upload_progress.label": "Nahrávání...",
  "upload_progress.processing": "Zpracovávání…",
  "username.taken": "Toto uživatelské jméno je obsazeno. Zkuste jiné",
  "video.close": "Zavřít video",
  "video.download": "Stáhnout soubor",
  "video.exit_fullscreen": "Ukončit režim celé obrazovky",
  "video.expand": "Rozbalit video",
  "video.fullscreen": "Režim celé obrazovky",
  "video.hide": "Skrýt video",
  "video.mute": "Ztlumit",
  "video.pause": "Pauza",
  "video.play": "Přehrát",
  "video.skip_backward": "Přeskočit zpět",
  "video.skip_forward": "Přeskočit vpřed",
  "video.unmute": "Zrušit ztlumení",
  "video.volume_down": "Snížit hlasitost",
  "video.volume_up": "Zvýšit hlasitost",
  "visibility_modal.button_title": "Nastavit viditelnost",
  "visibility_modal.direct_quote_warning.text": "Pokud uložíte aktuální nastavení, vložená citace bude převedena na odkaz.",
  "visibility_modal.direct_quote_warning.title": "Citace nemohou být vloženy do soukromých zmínek",
  "visibility_modal.header": "Viditelnost a interakce",
  "visibility_modal.helper.direct_quoting": "Soukromé zmínky, které jsou vytvořeny na Mastodonu, nemohou být citovány ostatními.",
  "visibility_modal.helper.privacy_editing": "Viditelnost nelze změnit po publikování příspěvku.",
  "visibility_modal.helper.privacy_private_self_quote": "Citace vlastních soukromých příspěvků nelze zveřejnit.",
  "visibility_modal.helper.private_quoting": "Příspěvky pouze pro sledující, které jsou vytvořeny na Mastodonu, nemohou být citovány ostatními.",
  "visibility_modal.helper.unlisted_quoting": "Když vás lidé citují, jejich příspěvek bude v časové ose populárních příspěvků také skryt.",
  "visibility_modal.instructions": "Nastavte, kdo bude moci interagovat s tímto příspěvkem. Tyto nastavení též můžete změnit pro všechny budoucí příspěvky v <link>Nastavení > Výchozí nastavení příspěvků</link>.",
  "visibility_modal.privacy_label": "Viditelnost",
  "visibility_modal.quote_followers": "Pouze sledující",
  "visibility_modal.quote_label": "Kdo může citovat",
  "visibility_modal.quote_nobody": "Jen já",
  "visibility_modal.quote_public": "Kdokoliv",
  "visibility_modal.save": "Uložit"
}
